import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import $ from '@sparta.global.vendors/jquery';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es5.js';
import spartaGlobalFunctions from '@sparta.global.utilities/sparta-global-functions-utility/dist/es5.js';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es5.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es5.js';
import { cardHelper } from '@sparta.global.helpers/card-helper/dist/es5.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { buttonGroup } from '@sparta.global.helpers/button-group-helper/dist/es5.js';

/* eslint-disable no-param-reassign */

// create localized instance of settings
var instance$2 = {};

// Default Options and Configuration Constants
var DefaultOptions = {
  drawer: {
    positions: ['bottom', 'right', 'left'],
    defaultPosition: 'right',
    sizes: ['small', 'medium', 'large'],
    defaultSize: 'medium'
  }
};

/**
 * Helper utility for the Sparta UI Layers Utility.
 * Separates the modal specific functions out from shared utility functions.
 * Usage example: SpartaUILayersModal.buildHTML(o);
 */
var SpartaUILayersModal = {
  /**
   * Builds HTML and readies it for the DOM.
   * @param {object} utility - The base UI Layers Utility, so we have access to parent functions.
   * @param {object} options - Object provided by `spartaUILayersUtility`.
   * @param {object} $link - Trigger that called for modal.
   * @param {object} classDefaults - Object of default classes for modal.
   * @param {object} linkDefaults - Object of default classes for trigger link.
   * @returns {object} The DOM element with card markup.
  */
  buildHTML: function buildHTML(utility, options, $link, classDefaults, linkDefaults) {
    var settings = new function SettingsConstructor() {
      var _this$classesToAdd;
      this.modalID = options.layerId;
      this.contentWrapperId = options.rel || 'modalContentInt';
      this.dismissible = options.closeButton !== false;

      // This is created from `_formatCloseLink` in the parent utility.
      this.modalCloseText = "".concat(options.closeText);
      this.modalAdaText = "".concat(this.modalCloseText, " ").concat(options.closeAdaText).trim();
      this.continueLink = options.module === 'global-social-module' ? options.interstitial.continueLink : $link.attr('href');
      this.anchorID = $link.attr('id');
      this.titleTag = 'h1';
      this.classesToAdd = [options.interstitialType ? 'spa-ui-modal-interstitial' : 'spa-ui-modal-default', options.layerClass];
      this.size = options.size;

      // Add classes for modals and drawers
      switch (options.type) {
        case 'drawer':
          // Unknown option value, use default
          if (!DefaultOptions.drawer.positions.includes(options.drawerPosition)) {
            options.drawerPosition = DefaultOptions.drawer.defaultPosition;
          }
          // Unknown option value, use default
          if (!DefaultOptions.drawer.sizes.includes(options.size)) {
            options.size = DefaultOptions.drawer.defaultSize;
          }
          (_this$classesToAdd = this.classesToAdd).push.apply(_this$classesToAdd, [options.drawerLayer.class, "".concat(options.drawerLayer.class, "-").concat(options.drawerPosition), "".concat(options.drawerLayer.class, "-").concat(options.size)]);
          break;
        default:
          this.classesToAdd.push(options.modalLayer.class);
      }

      // Add any extra classes specified in the layer options.
      if (options.optionalClasses) {
        this.classesToAdd = this.classesToAdd.concat(options.optionalClasses.split(' '));
      }

      // get defaults from utility
      this.classDefaults = classDefaults;
      this.linkDefaults = linkDefaults;

      // content object for interstitial modals
      if (options.module === 'global-social-module') {
        this.interstitialContent = options.interstitial;
      } else {
        this.interstitialContent = utility.layers[options.interstitialType];
      }

      // get branding from global params
      this.skin = SpartaUILayersModal.setBranding(options.interstitialType && options.interstitialType.length ? options.interstitialBranding : options.branding, options.interstitialType && options.interstitialType.length > 0);

      // get modal title
      if (this.interstitialContent) {
        this.title = new Handlebars.SafeString(this.interstitialContent.header).string;
      } else if ($(options.$content).find("#".concat(options.contentId, "_title"))) {
        this.title = $(options.$content).find("#".concat(options.contentId, "_title")).html();
      } else {
        this.title = options.modalTitle || options.title || options.titleText;
      }

      // get modal body content
      if (this.interstitialContent) {
        this.content = new Handlebars.SafeString(this.interstitialContent.body).string;
      } else if (options.$content instanceof $) {
        this.content = options.$content.detach().removeClass('hide');
      } else {
        this.content = options.$content;
      }
    }();

    // add settings to instance so we can reference it in API calls
    instance$2[settings.modalID] = settings;

    // if we're an interstitial modal we need to add CTAs
    if (settings.interstitialContent) {
      settings.content = SpartaUILayersModal.modalCTA(options, settings);
    } else if (!settings.title) {
      // update settings for titleTag and title string
      // if multiple titles than change titleTag to div
      // if no title given use ADA string as backup
      SpartaUILayersModal.setTitleFromADA(settings, options);
    }

    // Build card JCR structure.
    var modalCardJCR = {
      dismissible: settings.dismissible,
      dismissibleADA: settings.interstitialContent ? new Handlebars.SafeString("".concat(options.closeText, " ").concat(options.closeAdaText)).string : settings.modalAdaText,
      dismissibleClass: 'spa-ui-layer-close',
      title: settings.title || '',
      titleTag: settings.titleTag,
      skin: settings.skin,
      size: settings.size,
      markup: {
        content: ' ' // Note: To retain click events, this has to be built after card init.
      },
      config: {
        titleID: "".concat(options.contentId, "_title"),
        bodyID: settings.interstitialContent ? "".concat(options.contentId) : ''
      }
    };

    // Return DOM element with card markup.
    return SpartaUILayersModal.formatHTML(utility, options, settings, modalCardJCR);
  },
  /**
   * Formats the modal output and provides it with correct classes and inline styles.
   * @param {object} utility - The base UI Layers Utility, so we have access to parent functions.
   * @param {object} options - Object provided by `spartaUILayersUtility`.
   * @param {object} settings - Object compiled in `buildHTML`.
   * @param {object} modalCardJcr - DOM element that the modal has been injected into.
   * @returns {object} The modal layer DOM element.
  */
  formatHTML: function formatHTML(utility, options, settings, modalCardJcr) {
    // create new modal div for content injections
    var modalLayerElement = document.createElement('div');
    modalLayerElement.id = options.layerId;
    modalLayerElement.style.zIndex = utility._getNextZindex(options);
    settings.classesToAdd.forEach(function (name) {
      modalLayerElement.classList.add(name);
    });

    // append card helper markup    
    modalLayerElement.innerHTML = "\n      <div class=\"spa-dialog\" role=\"dialog\" aria-modal=\"true\" aria-describedby=\"".concat(options.contentId, "_blankDesc\">\n        <span id=\"").concat(options.contentId, "_blankDesc\" class=\"ada-hidden\">&nbsp;</span>\n        <div class=\"focus-boundary-top ada-hidden cnx-regular\" aria-hidden=\"false\">\n          ").concat(spartaGlobalFunctions.getGlobalParams('layerStart') || 'Start of dialog content', "\n        </div>\n        ").concat(cardHelper({}, modalCardJcr).string, "\n        <div class=\"focus-boundary-bottom ada-hidden cnx-regular\" aria-hidden=\"false\">\n          ").concat(spartaGlobalFunctions.getGlobalParams('layerEnd') || 'End of dialog content', "\n        </div>\n      </div>\n    ").replace(/[\t\n\r]/gm, '');

    // if interstitial modal add content wrapper for base utility functionality
    if (settings.interstitialContent) {
      $(modalLayerElement).find('.spa-card__body').append(settings.content);
      $(modalLayerElement).find('.spa-card__body').wrapInner('<div class=\'content\'></div>');
    } else if (settings.content instanceof $) {
      // if standard modal re-attach content provided by DOM
      settings.content.appendTo($(modalLayerElement).find('.spa-card__body'));
    } else {
      $(modalLayerElement).find('.spa-card__body').append(settings.content);
    }

    // if no title is not found, try looking in content
    // move any titles from content into card title section
    if (!modalLayerElement.querySelector('.spa-card__title')) {
      SpartaUILayersModal.formatTitle(options, modalLayerElement);
    } else if (modalLayerElement.querySelector(".spa-card__body #".concat(options.contentId, "_title"))) {
      // remove title from body section if it was provided by content
      // add font data attribute to title
      if (modalLayerElement.querySelector('.spa-card__title')) {
        modalLayerElement.querySelector('.spa-card__title').setAttribute('data-font', 'cnx-bold');
      }

      // remove base title that is added by helper
      modalLayerElement.querySelector(".spa-card__body #".concat(options.contentId, "_title")).remove();
    }

    // Add sticky footer to modal.
    if (modalLayerElement.querySelector('[data-modal-footer]')) {
      var modalFooterElement = utility.createStickyFooter(modalLayerElement, options);
      modalLayerElement.querySelector('.spa-card').appendChild(modalFooterElement);
    }

    // Add ADA rules to wrapper
    var modalTitle = modalLayerElement.querySelector('.spa-card__title');
    if (options.closeAdaTextOverride) {
      modalLayerElement.querySelector('.spa-dialog').setAttribute('aria-label', options.closeAdaTextOverride);
    } else if (modalTitle && modalTitle.id) {
      modalLayerElement.querySelector('.spa-dialog').setAttribute('aria-labelledby', modalTitle.id);
    }

    // return modal ready DOM element
    return modalLayerElement;
  },
  /**
   * Updates the settings object. If multiple titles, then change `titleTag` to `div`. If no title
   * given, use ADA string as backup.
   * @param {object} settings - Object containing quick lookups.
   * @param {object} options - Object provided by `spartaUILayersUtility`.
   * @returns {object} The modified settings.
   */
  setTitleFromADA: function setTitleFromADA(settings, options) {
    // get content from jquery element array
    var content = settings.content ? settings.content[0] : null;

    // if no content kill check
    if (!content) {
      return false;
    }

    // see if multiple titles are part of content
    var childrenElements = _toConsumableArray(content.querySelectorAll('h1, h2, h3, h4, h5, h6'));

    // limit title scope to everything outside of the content area
    var titleItems = [];
    childrenElements.forEach(function (item) {
      var contentBody = content.querySelector('.content');
      if (contentBody && !contentBody.contains(item)) {
        titleItems.push(item);
      }
    });

    // if multiple title items wrap in div instead of header tag
    if (titleItems.length) {
      settings.titleTag = 'div';
    } else if (!settings.title) {
      // If still using an H1 but no title is set, use the ADA heading string as backup.
      // This value is set by `_formatCloseLink` in the parent utility.
      settings.title = options.title || options.titleText;
    }
    return settings;
  },
  /**
   * When title is empty, check content for a title. It might by dynamic and tied to click events.
   * @param {object} options - Settings from the base utility for modal instance.
   * @param {object} modalLayerElement - DOM element used between utility helper bracket subsets.
   * @returns {void}
  */
  formatTitle: function formatTitle(options, modalLayerElement) {
    // get title from content
    var childrenElements = _toConsumableArray(modalLayerElement.querySelectorAll('h1, h2, h3, h4, h5, h6'));
    var modalCard = modalLayerElement.querySelector('.spa-card');
    var modalBody = modalLayerElement.querySelector('.spa-card__body');
    var modalContent = modalBody.querySelector('.content');
    var modalTitle = modalLayerElement.querySelector('.spa-card__head-wrapper');

    // if no card title wrapper found, create one
    if (!modalTitle) {
      // create title element wrapper
      var modalLayerTitleWrapperElement = document.createElement('div');
      modalLayerTitleWrapperElement.classList.add('spa-card__head');
      modalLayerTitleWrapperElement.innerHTML = '<div class="spa-card__head-wrapper"></div>';
      if (modalCard) {
        modalCard.insertBefore(modalLayerTitleWrapperElement, modalBody);
        modalTitle = modalLayerElement.querySelector('.spa-card__head-wrapper');
      }
    }

    // create title element wrapper
    var modalLayerTitleElement = document.createElement('div');
    modalLayerTitleElement.id = "".concat(options.contentId, "_title");
    modalLayerTitleElement.classList.add('spa-card__title');

    // test if header tag is inside .content div b/c we want to leave those alone
    var titleItems = [];
    childrenElements.forEach(function (item) {
      if (!modalContent.contains(item)) {
        titleItems.push(item);
      }
    });

    // append items into title
    titleItems.forEach(function (item) {
      modalLayerTitleElement.appendChild(item);
    });

    // inject title from content
    if (modalTitle && modalLayerTitleElement.childNodes.length) {
      modalTitle.insertBefore(modalLayerTitleElement, modalTitle.childNodes[0]);

      // If after all this, only one title is found update its tag to H1
      var checkTitleLength = _toConsumableArray(modalTitle.querySelectorAll('h1, h2, h3, h4, h5, h6'));
      if (checkTitleLength.length === 1) {
        var currentElement = checkTitleLength[0];
        var tagSwap = document.createElement('h1');
        tagSwap.innerHTML = currentElement.innerHTML;
        currentElement.parentNode.replaceChild(tagSwap, currentElement);
      }
    }
  },
  /**
   * Returns a skin string used by the Card Helper and produced by the UI Layers Utility.
   * @param {string} branding - A branding identifier.
   * @returns {string} The card skin identifier.
   */
  setBranding: function setBranding(branding) {
    var isInterstitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var cardSkin;
    switch (branding) {
      // We no longer accept these old values
      case 'co-brand':
      case 'enterprise':
        throw new TypeError("interstitialBranding '".concat(branding, "' is now deprecated. Please use 'red' instead."));
      case 'edge':
        throw new TypeError("interstitialBranding '".concat(branding, "' is now deprecated. Please use 'blue' instead."));
      case 'enterprise-two':
      case 'small-biz':
        throw new TypeError("interstitialBranding '".concat(branding, "' is now deprecated. Please use 'grey' instead."));
      case 'blue':
        cardSkin = 'blue';
        break;
      case 'grey':
        cardSkin = 'gray';
        break;
      case 'white':
        cardSkin = 'white';
        break;
      case 'default':
      case 'red':
        cardSkin = 'red';
        break;
      default:
        if (isInterstitial) {
          console.warn("interstitialBranding '".concat(branding, "' is not a supported value. Please use one of the 'interstitialBranding' values documented on the Sparta Modal demo page instead."));
          cardSkin = 'red';
        } else {
          cardSkin = 'white';
        }
    }
    return cardSkin;
  },
  /**
   * Gets CTA button items for interstitial modals.
   * @param {object} options - Contains object information from parent-level utility.
   * @param {object} settings - Quick lookups for to dynamically create modal content.
   * @returns {string} The modified markup.
   */
  modalCTA: function modalCTA(options, settings) {
    // interstitial modals sometimes have DOM injection points required by app devs
    var placementDomElement = '<p class="site-specific-placeholder-content"></p>';

    // Some buttons don't have global param values so set a default
    var cancelBtnText = settings.interstitialContent.btnText2[options.interstitialBranding] || settings.interstitialContent.btnText2.default || settings.interstitialContent.btnText2;
    var interstitialButtons = {
      alignment: "",
      buttons: [{
        content: "".concat(settings.interstitialContent.btnText1),
        modifiers: "primary",
        size: "small",
        class: "spa-ui-modal-btn--continue spa-btn spa-btn--small spa-btn--primary ".concat(options.targetAction === 'new-tab' ? ' close-interstitial' : '', "\n            ").concat(options.btnSpacing === true ? ' close-spacing' : ''),
        attributes: {
          id: "".concat(settings.anchorID).concat(settings.classDefaults.continueLinkPostfixID),
          type: "button"
        }
      }, {
        content: "".concat(cancelBtnText),
        modifiers: "secondary",
        size: "small",
        class: "spa-ui-modal-btn--cancel spa-btn spa-btn--small spa-btn--secondary close-interstitial",
        attributes: {
          "id": "".concat(settings.anchorID).concat(settings.classDefaults.backLinkPostfixID),
          "type": "button"
        }
      }]
    };
    var template = buttonGroup(interstitialButtons);

    // Class

    // Class to align footer buttons of modal.
    var footerBtnAlign = options.footerBtnAlign ? options.footerBtnAlign : '';

    // Wrap footer buttons.
    var footerBtn = "<div class=\"spa-btn-footer ".concat(footerBtnAlign, "\">").concat(template, "</div>");

    // append buttons to content
    settings.content += "".concat(placementDomElement).concat(footerBtn);
    return settings.content;
  },
  /**
   * When interstitial modals of the same type are called within a page, we need to update the URL
   * being provided.
   * @param {object} $layer - A jQuery object from the base utility containing modal DOM element.
   * @param {string} url - String URL that will replace the HREF value for modal "Continue" button.
   * @returns {void}
   */
  updateModalCTA: function updateModalCTA($layer, url) {
    // if $layer is jQuery object, get first index otherwise get the provided element
    var layerElm = $layer.length ? $layer[0] : $layer;

    // kill check
    if (!layerElm || url && typeof url !== 'string') {
      return;
    }
  },
  /**
   * Helper function to manually update the modal title on change events.
   * @param {object} $layer - A jQuery object from the base utility containing modal DOM element.
   * @param {string} titleText - HTML or string to inject into title.
   * @param {boolean} updateAdaText - Update the dismissible string on change.
   * @param {string} modalId - ID of target layer.
   * @returns {void}
   */
  setTitle: function setTitle($layer, titleText, updateAdaText, modalId) {
    // length check done in parent utility - just grab the first index
    var modalWrapper = $layer[0];
    var updateADA = updateAdaText;
    var options;
    if (modalId.includes('SpartaUILayer')) {
      options = instance$2["".concat(modalId)];
    } else {
      options = instance$2["".concat(modalId, "SpartaUILayer")];
    }
    if (!options) {
      return;
    }

    // get modal title
    var modalTitle = modalWrapper.querySelector('.spa-card__title');
    var modalDismissible = modalWrapper.querySelector('.spa-card__dismissible');

    // update dismissible
    if (modalDismissible && updateADA && 'modalCloseText' in options) {
      modalDismissible.setAttribute('aria-label', "".concat(options.modalCloseText).trim());
    }

    // if modal title, update it
    if (modalTitle) {
      modalTitle.innerHTML = titleText;
    }
  }
};

/* eslint-disable no-param-reassign */
var uiLayerNamespace = 'spartaUILayersUtilityTooltips';

/**
* Collection of console log strings.
* @constant {object}
*/
var LOGMESSAGE = {
  CLOSE_ADA_TEXT_OVERRIDE_DEPRECATED: "".concat(uiLayerNamespace, ": The 'closeAdaTextOverride' is deprecated and will remain for backward compatibility. Please use 'ariaLabel' for improved accessibilty."),
  NO_TITLE_ARIA_LABEL_MSG: "".concat(uiLayerNamespace, ": 'title' is missing in the JCR. Please provide 'ariaLabel' for accessibilty compliance.")
};

// create localized instance of settings
var instance$1 = {};

/**
 * Helper utility for the Sparta UI Layers Utility.
 * Separates the tooltip specific functions out from shared utility functions.
 * Usage example: SpartaUILayersTooltip.buildHTML(o);
 */
var SpartaUILayersTooltip = {
  /**
   * Builds HTML and readies it for the DOM.
   * @param {object} utility - The base UI Layers Utility, so we have access to parent functions.
   * @param {object} options - Object provided by `spartaUILayersUtility`.
   * @param {object} $link - Trigger that called for modal.
   * @returns {object} The DOM element with card markup.
  */
  buildHTML: function buildHTML(utility, options, $link) {
    var settings = new function SettingsConstructor() {
      this.tooltipId = options.layerId;
      this.contentWrapperId = options.rel || 'tooltipContentInt';
      this.continueLink = $link.attr('href');
      this.anchorID = $link.attr('id');
      this.titleTag = 'h3';
      this.type = options.type;

      // This is created from `_formatCloseLink` in the parent utility.
      this.tooltipCloseText = "".concat(options.closeText);
      this.tooltipAdaText = "".concat(this.tooltipCloseText, " ").concat(options.closeAdaText).trim();
      this.classesToAdd = [options.layerClass, options.infoLayer.class, SpartaUILayersTooltip.getContentLength(options).sizeClass];

      // Detach this to retain click events. Will be added back in `formatHTML` function.
      this.content = options.$content.removeClass('hide').detach();

      // get title
      this.title = $(options.$content).find("#".concat(options.contentId, "_title")) ? $(options.$content).find("#".concat(options.contentId, "_title")).html() : undefined;

      // If no title, look to data-options.
      if (!this.title) {
        this.title = options.modalTitle || options.title;
      }
    }();
    if (settings.type === 'info-inline') {
      settings.classesToAdd.push("spa-ui-info-".concat(options.type));
    }

    // Clean up the title.
    if (settings.title) {
      settings.title = settings.title.trim();
      settings.title = "".concat(settings.title.charAt(0).toUpperCase()).concat(settings.title.slice(1));
    }

    // build card JCR structure
    var tooltipCardJCR = {
      dismissible: true,
      dismissibleADA: settings.tooltipAdaText || '',
      dismissibleClass: 'spa-ui-layer-close',
      class: !settings.title ? 'spa-ui-info--no-title' : '',
      title: settings.title || '',
      titleTag: settings.titleTag,
      markup: {
        content: ' ' // Note: To retain click events, this has to be built after card init.
      },
      config: {
        titleID: "".concat(options.contentId, "_title")
      }
    };

    // add settings to instance so we can reference it in API calls
    instance$1[settings.tooltipId] = settings;

    // return DOM element with card markup
    return SpartaUILayersTooltip.formatHTML(utility, options, settings, tooltipCardJCR);
  },
  /**
   * Formats the tooltip output and provides it with correct classes and inline styles.
   * @param {object} utility - The base UI Layers Utility, so we have access to parent functions.
   * @param {object} options - Object provided by `spartaUILayersUtility`.
   * @param {object} settings - Object compiled in `buildHTML`.
   * @param {object} tooltipCardJcr - DOM element that the tooltip has been injected into.
   * @returns {object} The tooltip layer DOM element.
  */
  formatHTML: function formatHTML(utility, options, settings, tooltipCardJcr) {
    // create new modal div for content injections
    var tooltipLayerElement = document.createElement('div');
    tooltipLayerElement.id = options.layerId;
    tooltipLayerElement.style.zIndex = utility._getNextZindex(options);
    settings.classesToAdd.forEach(function (name) {
      tooltipLayerElement.classList.add(name);
    });

    // append card helper markup
    tooltipLayerElement.innerHTML = cardHelper({}, tooltipCardJcr).string;

    // Add content to modal. It comes from a jQuery object, and we always want the first element.
    tooltipLayerElement.querySelector('.spa-card__body').appendChild(settings.content[0]);

    // remove title from content if one was present
    if (settings.title && tooltipLayerElement.querySelector('.spa-ui-layer-title')) {
      tooltipLayerElement.querySelector('.spa-ui-layer-title').remove();
    }

    // Add ADA rules to wrapper
    var modalTitle = tooltipLayerElement.querySelector('.spa-card__title');
    tooltipLayerElement.setAttribute('role', 'dialog');
    if (options.closeAdaTextOverride) {
      tooltipLayerElement.setAttribute('aria-label', options.closeAdaTextOverride);
      console.log(LOGMESSAGE.CLOSE_ADA_TEXT_OVERRIDE_DEPRECATED);
    } else if (modalTitle && modalTitle.id) {
      tooltipLayerElement.setAttribute('aria-labelledby', modalTitle.id);
    }

    // Adds aria label for tooltip with no title 
    var existingAriaLabel = tooltipLayerElement.hasAttribute('aria-label') || tooltipLayerElement.hasAttribute('aria-labelledby');
    if (!options.title && !existingAriaLabel) {
      if (options.ariaLabel) {
        tooltipLayerElement.setAttribute('aria-label', options.ariaLabel);
      } else {
        console.log(LOGMESSAGE.NO_TITLE_ARIA_LABEL_MSG);
      }
    }

    // Add sticky footer to tooltip.
    if (tooltipLayerElement.querySelector('[data-modal-footer]')) {
      var tooltipFooterElement = utility.createStickyFooter(tooltipLayerElement, options);
      tooltipLayerElement.querySelector('.spa-card').appendChild(tooltipFooterElement);
    }

    // return modal ready DOM element
    return tooltipLayerElement;
  },
  /**
   * Uses the content length to determine spacing for tooltip.
   * @param {object} options - Object provided by `spartaUILayersUtility`.
   * @returns {object} A width value and size class.
  */
  getContentLength: function getContentLength(options) {
    // Dynamically set width based on amount of content.
    var contentEl = options.$content.find(' > :not(".ada-hidden")');
    var contentLength = contentEl ? contentEl.text().replace(/ {2,}/g, ' ').length : 0;
    var widthValue;
    var sizeClass;
    if (contentLength < options.infoLayer.width.small.chars) {
      widthValue = options.infoLayer.width.small.width;
      sizeClass = options.infoLayer.width.small.class;
    } else if (contentLength < options.infoLayer.width.medium.chars) {
      widthValue = options.infoLayer.width.medium.width;
      sizeClass = options.infoLayer.width.medium.class;
    } else {
      widthValue = options.infoLayer.width.large.width;
      sizeClass = options.infoLayer.width.large.class;
    }
    return {
      widthValue: widthValue,
      sizeClass: sizeClass
    };
  },
  /**
   * Creates a DOM element to notify user they've hit end of tooltip layer.
   * @param {object} options - Object provided by `spartaUILayersUtility`.
   * @returns {object} The generated DOM element.
  */
  createEndOfElement: function createEndOfElement(options) {
    var tooltipEndOfElement = document.createElement('div');
    tooltipEndOfElement.classList.add('ada-hidden');
    tooltipEndOfElement.innerHTML = "".concat(options.endContentMsg);
    return tooltipEndOfElement;
  },
  /**
   * Helper function to manually update the tooltip title.
   * @param {object} $layer - jQuery object of modal to target.
   * @param {string} titleText - HTML or string to inject into title.
   * @param {boolean} updateAdaText - Update the dismissible string on change.
   * @param {string} tooltipId - ID of target layer.
   * @returns {void}
   */
  setTitle: function setTitle($layer, titleText, updateAdaText, tooltipId) {
    // length check done in parent utility - just grab the first index
    var tooltipWrapper = $layer[0];
    var updateADA = updateAdaText;
    var options;
    if (tooltipId.includes('SpartaUILayer')) {
      options = instance$1["".concat(tooltipId)];
    } else {
      options = instance$1["".concat(tooltipId, "SpartaUILayer")];
    }
    if (!options) {
      return;
    }

    // get modal title
    var tooltipTitle = tooltipWrapper.querySelector('.spa-card__title');
    var tooltipDismissible = tooltipWrapper.querySelector('.spa-card__dismissible');

    // update dismissible
    if (tooltipDismissible && updateADA && 'tooltipCloseText' in options) {
      tooltipDismissible.setAttribute('aria-label', "".concat(options.tooltipCloseText, ": ").concat(titleText).trim());
    }

    // if modal title, update it
    if (tooltipTitle) {
      tooltipTitle.innerHTML = titleText;
    }
  }
};

/* eslint-disable max-len */

/**
 * Toggle aria-hidden on every element parent of layer
 * This leaves a path for screen readers to travel down DOM to find nested modals in widgets
 * @param {Object} primaryElm layer element
 * @param {Boolean} isHidden boolean if layer is hidden or not
 */
function toggleSiblings(primaryElm, isHidden) {
  if (!primaryElm || primaryElm.tagName === 'BODY') {
    return;
  }

  // Get siblings
  var siblingElms = _toConsumableArray(primaryElm.parentElement.children);

  // Filter siblings
  siblingElms = siblingElms.filter(function (item) {
    return item !== primaryElm && item.tagName !== 'SCRIPT' && item.tagName !== 'STYLE' && item.tagName !== 'NOSCRIPT';
  });

  // Loop through and toggle
  siblingElms.forEach(function (element) {
    // Set temp attribute to save states of elements that may have this value set
    var alreadyHasAriaHiddenSetting = element.hasAttribute('aria-hidden');
    if (isHidden && alreadyHasAriaHiddenSetting) {
      element.setAttribute('data-save-aria-state', element.getAttribute('aria-hidden'));
    }

    // Update state
    element.setAttribute('aria-hidden', isHidden);

    // Re-add the default state for elements we overwrote
    if (!isHidden) {
      if (element.getAttribute('data-save-aria-state')) {
        element.setAttribute('aria-hidden', element.getAttribute('data-save-aria-state'));
        element.removeAttribute('data-save-aria-state');
      } else {
        element.removeAttribute('aria-hidden');
      }
    }
  });
  toggleSiblings(primaryElm.parentElement, isHidden);
}

/**
 * Add focus trap and other ADA
 * @param {Object} o - Layer settings object
 * @param {Jquery Object} layer - jQuery DOM element for the ui-layer wrapping element
 * @param {Object} _this - Utility instance setter
 */
function focusTrapSetter(layer, _this) {
  setTimeout(function () {
    layer.attr('tabindex', '-1');
    window.addEventListener('keydown', _this.focusTrap, false);
    window.addEventListener('touchend', _this.focusTrap, false);
    window.focusTrapSettings = {
      layer: layer[0]
    };
  }, 50);
}

/**
 * For inline tooltips, this defines how the ADA logic is tied back to the dialog selector
 * @param {Object} o - Layer settings object
 */
function inlineTooltipAda(o) {
  // Get parent modal and get selector attributes
  var tooltipWrapper = document.querySelector("#".concat(o.layerId));
  var modalWrapper = tooltipWrapper.closest('.spa-ui-modal');
  var modalLabelledBy = modalWrapper && modalWrapper.querySelector('.spa-dialog') ? modalWrapper.querySelector('.spa-dialog').getAttribute('aria-labelledby') : undefined;
  var modalLabel = modalWrapper && modalWrapper.querySelector('.spa-dialog') ? modalWrapper.querySelector('.spa-dialog').getAttribute('aria-label') : undefined;

  // Determine if we need to add ADA logic. Based on settings, this could be set by inline JCR
  if ((modalLabelledBy || modalLabel) && !tooltipWrapper.hasAttribute('aria-label') && !tooltipWrapper.hasAttribute('aria-labelledby')) {
    if (modalLabelledBy) {
      tooltipWrapper.setAttribute('aria-labelledby', modalLabelledBy);
    } else if (modalLabel) {
      tooltipWrapper.setAttribute('aria-label', modalLabel);
    }
  }
}

/**
 * @module
 * @name sparta-ui-layers-utility
 * @desc export a singleton instance of spartaUILayersUtility class
 */

// Default settings for UI Layers class.
var classDefaults = {
  debug: false,
  evtNamespace: 'spaUILayer',
  closeLayerNameSpace: 'info-layer-evt',
  initNamespace: 'sparta-ui-layers-utility',
  scrollNamespace: 'scrollfix',
  globalReady: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility',
  globalReadyToken: '',
  layerClass: 'spa-ui-layer',
  layerPosition: '',
  linkClass: 'spa-ui-layer-link',
  closeClass: 'spa-ui-layer-close',
  openClass: 'spa-ui-layer-opened',
  activeTooltip: 'spa-ui-tooltip-open',
  activeDrawer: 'spa-ui-drawer-open',
  activeModal: 'spa-ui-modal-open',
  noCloseFocus: 'spa-card__ada-msg',
  noCloseFocusAuto: true,
  adaLayerID: 'SpartaUILayer',
  adaCloseID: 'Close',
  drawerLayerClass: 'spa-ui-drawer',
  modalLayerClass: 'spa-ui-modal',
  infoLayerClass: 'spa-ui-info',
  infoInlineLayerClass: 'spa-ui-info-info-inline',
  layerLinkOffset: 14,
  // Distance between link and layer for tooltip.
  layerIconOffset: 14,
  // Distance between icon and layer for tooltip.
  layerCaret: 14,
  // Height of the layer caret.
  nextZIndex: 1001,
  continueLinkPostfixID: 'ContinueLink',
  backLinkPostfixID: 'BackLink',
  spartaLayoutContainer: '.spa-layout-container',
  // Page container.
  adaSkipLinkID: '#ada-skip-link'
};
var classLists = {
  // Modals, Drawers, and info-inline
  layers: [classDefaults.drawerLayerClass, classDefaults.modalLayerClass, classDefaults.infoInlineLayerClass],
  // Modals, Drawers, not info/tooltip
  modalLayers: [classDefaults.drawerLayerClass, classDefaults.modalLayerClass],
  // When the Layer is Marked Open
  activeClasses: [classDefaults.activeModal, classDefaults.activeDrawer, classDefaults.activeTooltip]
};

// Composite selectors to be used in multiple locations throughout this file
var constSelectors = Object.entries(classLists).reduce(function (obj, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    arr = _ref2[1];
  obj[key] = arr.filter(function (c) {
    return typeof c === 'string' && c.length > 0;
  }).map(function (c) {
    return ".".concat(c);
  }).join(',');
  return obj;
}, {});

// Default settings for modal layer links.
var linkDefaults = {
  modalIdArray: [],
  type: null,
  // Required. [ modalLayer | drawerLayer | infoLayer | taskLayer ]
  width: null,
  // Optional.
  layerId: null,
  layerCloseId: null,
  layerClass: 'spa-ui-layer',
  optionalClasses: '',
  onOpen: '',
  // Callback for when the modal is opened (string).
  onClose: '',
  // Callback for when the modal is closed (string).
  closeButton: true,
  // Whether to include close button in layer.
  closeTriggers: [],
  // Pass in optional close links and buttons as a string or jQuery object.
  closeOnEscape: true,
  // Whether to close the modal using Esc key.
  closeOnClickOutside: true,
  closeAdaText: '',
  closeAdaTextSpacer: ': ',
  closeAdaTextOverride: '',
  interstitialType: '',
  adaCloseFocus: false,
  // Overwrite default close icon styling for focus against dark backgrounds?
  interstitialBranding: 'default',
  dynamicContent: false,
  enableDynamicHeight: false,
  // Enables dynamic height for tooltip content
  loadingText: '',
  drawerPosition: 'right',
  targetAction: '',
  drawerLayer: {
    class: classDefaults.drawerLayerClass
  },
  modalTitle: '',
  modalLayer: {
    class: classDefaults.modalLayerClass,
    width: 600
  },
  infoLayer: {
    class: classDefaults.infoLayerClass,
    layerAdjustTop: 10,
    layerAdjustLeft: 10,
    width: {
      small: {
        chars: 350,
        width: 250,
        class: "".concat(classDefaults.infoLayerClass, "-small")
      },
      medium: {
        chars: 800,
        width: 400,
        class: "".concat(classDefaults.infoLayerClass, "-medium")
      },
      large: {
        chars: 0,
        width: 400,
        class: "".concat(classDefaults.infoLayerClass, "-large")
      },
      default: {
        width: 250,
        class: "".concat(classDefaults.infoLayerClass, "-large")
      }
    }
  },
  stopPropagation: false
};

// Should follow the format `EVENT_NAME.spartaUILayersUtility:ModuleName`.
var EVENTS = {
  MODAL_OPENED: 'MODAL_OPENED.spartaUILayersUtility',
  MODAL_CLOSED: 'MODAL_CLOSE.spartaUILayersUtility',
  FREEZE_SCROLL: 'FREEZE_SCROLL.spartaUILayersUtility',
  UNFREEZE_SCROLL: 'UNFREEZE_SCROLL.spartaUILayersUtility'
};

// Options specific to the call we'll make to the constructor below.
var options = {
  debug: false,
  $applicationContainer: null,
  $body: $('body'),
  $html: $('html'),
  $window: $(window),
  $document: $(document),
  $context: null
};

/**
 * Class for global implementation of UI layers like modals, interstitials, and tooltips.
 */
var SpartaUILayersUtility = /*#__PURE__*/function () {
  /**
   * Initializes an instance of our global UI Layers class.
   */
  function SpartaUILayersUtility() {
    _classCallCheck(this, SpartaUILayersUtility);
    // Disable all modals, tooltips, etc. for Prerender.
    this.isPrerender = typeof startPrerenderCapture === 'function';
    if (this.isPrerender) {
      return;
    }

    // Extend class options based on defaults and provided constructor options.
    this.options = Object.assign({}, classDefaults, options);

    // Event binding for loading modals/tooltip as on-demand
    if (!widgetName) {
      // Add base listeners for opening via click methods.
      this.options.globalReadyToken = spartaEventsUtility.sub("".concat(this.options.globalReady), this._addListeners.bind(this, null));
    }
    this._addTriggerTypeClass(this.options.linkClass);

    // Get the current window width so we can prevent fake resize events when a mobile browser
    // hides and shows the URL bar.
    this.options.windowWidth = this.options.$window.width();
  }

  // This method will be invoked by widget loader only after loading this script
  return _createClass(SpartaUILayersUtility, [{
    key: "_initForWidgets",
    value: function _initForWidgets(_ref3) {
      var widgetId = _ref3.widgetId;
      // Add base listeners for opening via click methods.
      this.options.globalReadyToken = spartaEventsUtility.sub("".concat(this.options.globalReady), this._addListeners.bind(this, widgetId), false, {
        id: widgetId
      });
    }

    /**
     * Adds proper class name to ui-layer trigger based on type
     * @param {string} className - class to create list from
     * @returns {void}
     */
  }, {
    key: "_addTriggerTypeClass",
    value: function _addTriggerTypeClass(className) {
      // if the element that triggered this was a layer trigger link
      var uiLinkList = _toConsumableArray(document.querySelectorAll(".".concat(className)));
      uiLinkList.forEach(function (element) {
        // test parent node type to see if we need to modify element class
        if (element.parentElement.nodeName === 'ABBR') {
          return;
        }

        // get data attributes
        var targetID;
        var targetDataObj;
        var type;
        if (element && element.dataset && element.dataset.options) {
          var linkOptions;
          try {
            linkOptions = JSON.parse(element.dataset.options);
          } catch (e) {
            console.log("Error message: ".concat(e.message));
          }

          // Check data options for the modal type.
          if (linkOptions && linkOptions.interstitialType) {
            // If it's interstitial, then set the type to modal.
            type = 'modal';
          } else {
            // Otherwise, get the type from the `rel` attribute.
            targetID = element.getAttribute('rel');
          }
        }

        // if we have a target ID go find content in the DOM
        var target = targetID ? document.getElementById(targetID) : undefined;

        // If content DOM found, get the type.
        if (target && target.dataset && target.dataset.options) {
          try {
            targetDataObj = JSON.parse(target.dataset.options);
          } catch (e) {
            console.log("Error message: ".concat(e.message));
          }
          if (targetDataObj && targetDataObj.type) {
            var _targetDataObj = targetDataObj;
            type = _targetDataObj.type;
          }
        }

        // finally, apply the proper class name to trigger
        if (['drawer', 'modal'].includes(type)) {
          element.classList.add('spa-ui-layer-modal-link');
        } else if (type === 'info') {
          element.classList.add('spa-ui-layer-tooltip-link');
        }
      });
    }

    /**
     * Retrieves the layers object. By default it will get it from the asset loader. If that's not
     * available, get it from `spaParams`. (This was necessary for Sparta widgets. It couldn't find
     * the layers and therefore failed to work.)
     * @returns {object} The layers.
     */
  }, {
    key: "layers",
    get: function get() {
      var lang = spartaGlobalFunctions.getLanguage();
      var spaParam = spartaGlobalFunctions.getSpaParams();
      var layersObj = spaParam.global[lang].layers;
      return layersObj;
    }

    /**
     * Returns an object containing event identifiers.
     * @returns {object} The event identifiers.
     */
  }, {
    key: "EVENTS",
    get: function get() {
      return EVENTS;
    }

    /**
     * Adds relevant event listeners for UI Layers.
     * @returns {void}
     */
  }, {
    key: "_addListeners",
    value: function _addListeners(widgetId) {
      // set applicationContainer
      this.options.$applicationContainer = $(spartaStoreUtility.getData('applicationContainer', {
        id: widgetId
      }));
      spartaEventsUtility.unsubByToken(this.options.globalReadyToken);
      if (this.options.$applicationContainer && this.options.$applicationContainer.length && this.options.$applicationContainer[0].hasAttribute('data-sparta-widget')) {
        spartaEventsUtility.unsubWidgetByToken(this.options.globalReadyToken);
      }
      var namespace = this.options.evtNamespace;
      this.options.$applicationContainer.on("click.".concat(namespace), ".".concat(this.options.linkClass), this._onLayerLinkClick.bind(this, widgetId));
      this.options.$applicationContainer.on("animationend.".concat(namespace, " oAnimationEnd.").concat(namespace, " webkitAnimationEnd.").concat(namespace), this._infoLayerAnimationEnd.bind(this));
    }

    /**
     * @param {string} url URL to load into the window
     * @param {string} windowName Name applied to popup
     * @param {string} args pop-up window arguments
     * @return {boolean} returns false always
     */
  }, {
    key: "displayPopup",
    value: function displayPopup(url, windowName) {
      var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'width=750,height=450,resizable,scrollbars';
      if (this.isPrerender) {
        return false;
      }
      if (url && windowName) {
        var newWindow = window.open(url, windowName, args);
        newWindow.focus();
      }
    }

    /**
     * Helps get popup options
     * @param {Element} elem 
     * @returns {Object}
     */
  }, {
    key: "getPopupArgs",
    value: function getPopupArgs(elem) {
      var args = '';
      var $elem = $(elem);
      var defaults = {
        block: false,
        height: 600,
        href: $elem.attr('href') || $elem.data('continue-link'),
        menubar: false,
        resizable: true,
        scrollbars: true,
        size: null,
        status: false,
        width: 400,
        windowName: 'spawin',
        x: 0,
        y: 0
      };
      var opts = Object.assign({}, defaults, $elem.data('options') || {});
      switch (opts.size) {
        case 'large':
          opts.height = 600;
          opts.width = 800;
          break;
        case 'medium':
          opts.height = 400;
          opts.width = 600;
          break;
        case 'small':
          opts.height = 200;
          opts.width = 300;
          break;
      }

      // Center window.
      // TODO: This doesn't center.
      opts.y = Math.floor((window.screen.availHeight - (opts.height || window.screen.height)) / 2) - (window.screen.height - window.screen.availHeight);
      opts.x = Math.floor((window.screen.availWidth - (opts.width || window.screen.width)) / 2) - (window.screen.width - window.screen.availWidth);

      // If block, just open default window/tab as full window.
      if (!opts.block) {
        var width = opts.width,
          height = opts.height,
          x = opts.x,
          y = opts.y;
        args = "".concat(args, "width=").concat(width, ",height=").concat(height, ",left=").concat(x, ",top=").concat(y);
        ['menubar', 'resizable', 'scrollbars', 'status'].forEach(function (toolbarFeature) {
          if (opts[toolbarFeature]) {
            args += ",".concat(toolbarFeature);
          }
        });
      }
      opts.args = args;
      return opts;
    }

    /**
     * Adds a popup window.
     * @param {nodelist} elements - List of elements to get helped.
     * @returns {void}
     */
  }, {
    key: "addPopupWindowHelper",
    value: function addPopupWindowHelper(elements) {
      var _this2 = this;
      if (this.isPrerender) {
        return;
      }
      var popupElements = Array.prototype.slice.call(elements, 0);
      popupElements.forEach(function (elem) {
        if (elem.getAttribute('data-popup-event-attached')) {
          return;
        }
        elem.addEventListener('click', function (event) {
          event.preventDefault();
          var opts = _this2.getPopupArgs(elem);
          _this2.displayPopup(opts.href, opts.windowName, opts.args);
          elem.classList.add('force-visited');
          return false;
        });
        elem.setAttribute('data-popup-event-attached', '1');
      });
    }

    /**
      * Standard close function for modal layers.
      * @param {object} event - The click event object.
      * @returns {void}
      */
  }, {
    key: "_onLayerLinkClick",
    value: function _onLayerLinkClick(widgetId, event) {
      var $this = $(event.currentTarget);
      var isEventInWidget = this._isEventInWidget(event);

      // Don't open layer if its coming from vue or if it is coming from a v5 widget
      var isVueComponent = event.currentTarget && event.currentTarget.getAttribute('vue-component') === 'true';
      if (!isVueComponent || !isEventInWidget) {
        this.openLayer($this, event, null, widgetId);
      }
    }
    /**
     * Check if current event target is in a widget app container.
     * @param {object} event - Click Event object
     * @returns {boolean}
     */
  }, {
    key: "_isEventInWidget",
    value: function _isEventInWidget(event) {
      var widgetContainers = document.querySelectorAll("div[data-sparta-widget]");
      var _iterator = _createForOfIteratorHelper(widgetContainers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var widget = _step.value;
          if (widget.contains(event.target)) return true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }

    /**
     * Listens for animation end event and remove layer if necessary.
     * @param {object} e - The animation event object.
     * @returns {void}
     */
  }, {
    key: "_infoLayerAnimationEnd",
    value: function _infoLayerAnimationEnd(e) {
      var $target = $(e.target);

      // if our element has faded out, hide it
      if ($target.hasClass('spa-ui-animate-fadeOutUp') || $target.hasClass('spa-ui-animate-fadeOutDown')) {
        $target.hide();
      }
    }

    /**
     * Sets layer options.
     * @param {object} [linkSpecificSettings] - Settings specific to links.
     * @param {object} [contentOptions] - Settings specific to this layer's content.
     * @param {object} [linkOptions] - Settings specific to this link.
     * @returns {object} The compiled layer options.
     */
  }, {
    key: "_setLayerOptions",
    value: function _setLayerOptions() {
      var linkSpecificSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var contentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var linkOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (contentOptions.type === 'drawer') {
        // Translate JCR position key to internal key
        contentOptions.drawerPosition = contentOptions.position;
        delete contentOptions.position;
      }
      return Object.assign({}, linkDefaults, linkSpecificSettings, contentOptions, linkOptions);
    }

    /**
     * Opens a UI layer by type all.
     * @param {string|object} obj - The ID of the layer, or a jQuery object.
     * @param {object} [e] - Event that opened layer (click, keypress), used for positioning logic.
     * @param {object} [layerOptions] - Options to add to the layer configuration.
     * @returns {void}
     * @example spartaUILayer.openLayer($this, event);
     */
  }, {
    key: "openLayer",
    value: function openLayer(obj, e, layerOptions, widgetId) {
      var _this3 = this;
      if (this.isPrerender) {
        return;
      }
      var event = e || {};

      // prevent default action for href.
      if (event.type) {
        event.preventDefault();
      }
      if (widgetId && event.stopPropagation) {
        event.stopPropagation();
      }

      // Convert `obj` to a jQuery collection if it isn't already one.
      var $obj = obj && !obj.jquery ? $(obj) : obj;

      // short circuit if no items are in our jQuery collection
      if (!$obj || !$obj.length) {
        this._debug('Error: spartaUILayer: Nothing passed in');
        return;
      }

      // overriding application container if passed in, otherwise resettings to spartaStore value
      this.options.$applicationContainer = event.$applicationContainer || $(spartaStoreUtility.getData('applicationContainer', {
        id: widgetId
      }));

      // if application container comes from a widget set a boolean check
      this.options.$applicationContainerDisableAriaHiddenToggle = false;
      if (this.options.$applicationContainer.hasClass('sparta-widget-container')) {
        this.options.$applicationContainerDisableAriaHiddenToggle = true;
      }
      var $link;
      var $content;
      var contentId;
      var linkOptions = {};
      var triggerLink;
      if (e) {
        triggerLink = e.currentTarget || e.target || e.srcElement;
      }

      // if the element that triggered this was a layer trigger link
      if ($obj.hasClass(this.options.linkClass)) {
        $link = $obj;
        linkOptions = $link.data('options') || {};
        contentId = $link.attr('rel');

        // if layer is an interstitial or another layer
        if (linkOptions.interstitialType) {
          linkOptions.type = 'modal';
          contentId = linkOptions.rel || "".concat(linkOptions.interstitialType, "-").concat(linkOptions.interstitialBranding || 'default');
        }
        $content = $("#".concat(contentId)) || null;
      } else if (triggerLink && triggerLink !== window) {
        $content = $obj;
        $link = $(triggerLink);
        contentId = $content.attr('id');
        if ($content.length && $content[0].module && $content[0].module === 'global-social-module') {
          linkOptions = $content[0];
        }
      } else if (e === null && layerOptions && layerOptions.returnFocusToLink) {
        $content = $obj;
        $link = $(layerOptions.returnFocusToLink);
        contentId = $content.attr('id');
      } else {
        $content = $obj;
        $link = this.options.$applicationContainer;
        contentId = $content.attr('id');
      }
      var contentOptions = $content.data('options') || linkOptions;
      var returnFocusToLink = event.currentTarget || event.target || event.srcElement;

      // data-options warning message check
      if (Object.keys(contentOptions).length === 0) {
        console.warn('Layer data-options parse failed or was empty', contentId || $link[0]);
      }

      // options for this link and layer based on current item
      var linkSpecificSettings = {
        closeADALabel: spartaGlobalFunctions.getGlobalParams('closeADALabel') || 'x: ',
        closeText: spartaGlobalFunctions.getGlobalParams('closeText') || 'close',
        $content: $content,
        contentId: contentId,
        startContentMsg: spartaGlobalFunctions.getGlobalParams('layerStart') || 'Start of [layerType] content',
        endContentMsg: spartaGlobalFunctions.getGlobalParams('layerEnd') || 'End of [layerType] content',
        endContentMsgShowOnFocus: true,
        returnFocusToLink: returnFocusToLink ? $(returnFocusToLink) : this.options.$applicationContainer,
        position: {
          browserWidth: this.options.$body.width(),
          applicationWidth: this.options.$applicationContainer.width(),
          activeMouseTop: event.pageY,
          activeMouseLeft: event.pageX,
          linkWidth: $link.width(),
          linkHeight: $link.height(),
          linkOffsetTop: $link ? 0 : $link.offset().top,
          linkOffsetLeft: $link ? 0 : $link.offset().left,
          screenTop: this.options.$document.scrollTop()
        }
      };

      // Extend the options for this layer. Order of importance: `link data-options`,
      // `layer data-options`, link-specific content options, `linkDefaults`.
      var o = this._setLayerOptions(linkSpecificSettings, contentOptions, linkOptions);

      // Add event.stopPropagation() to stop event from bubbling up if widget is used in sparta page.
      o.stopPropagation = $link.data('options') && typeof $link.data('options').preventEventPropagation !== 'undefined' && $link.data('options').preventEventPropagation.toString() === 'false' ? false : true;
      if (o.stopPropagation) {
        var stopPropagation = o.stopPropagation;
        if (spartaStoreUtility.getData('isWidget')) {
          var _spartaStoreUtility$g = spartaStoreUtility.getData('applicationContext', {
              id: widgetId
            }),
            name = _spartaStoreUtility$g.name,
            version = _spartaStoreUtility$g.version,
            id = _spartaStoreUtility$g.id;
          stopPropagation = window.spaWidgetParams[name][version][id].siteParams.preventEventPropagation;
        } else {
          stopPropagation = false;
        }
        if (stopPropagation) event.stopPropagation();
      }

      // Update card end of content message.
      o.typeNiceName = o.type === 'info' ? spartaGlobalFunctions.getGlobalParams('closeLayerADAText') || 'dialog' : spartaGlobalFunctions.getGlobalParams('closeModalADAText') || 'dialog';
      o.startContentMsg = o.startContentMsg.replace('[layerType]', o.typeNiceName.toLowerCase());
      o.endContentMsg = o.endContentMsg.replace('[layerType]', o.typeNiceName.toLowerCase());
      // If our JS calls the `openLayer` function, than override JCR/Default strings
      o = Object.assign({}, o, layerOptions);

      // if our returnFocusToLink value isn't a jQuery collection, convert it to one
      if (!(o.returnFocusToLink instanceof $)) {
        o.returnFocusToLink = this.options.$applicationContainer.find(o.returnFocusToLink).slice(0, 1);
      }

      // Support legacy objects using modalTitle instead of title.
      if (o.modalTitle) {
        o.title = o.modalTitle;
      }

      // if we don't have content from a link (opened onload?), find content from options passed in
      if (typeof o.$content === 'undefined') {
        o.$content = $("#".concat(o.contentId));

        // can't find target content
        if (typeof o.$content === 'undefined' && typeof o.interstitialType === 'undefined') {
          this._debug("cannot find: ".concat(o.contentId));
          return;
        }
      }

      // update unique IDs for ADA
      // give layer unique ID since tooltips can generate mutliple per page
      o.layerId = "".concat(o.contentId).concat(this.options.adaLayerID);
      o.layerCloseId = "".concat(o.layerId).concat(this.options.adaCloseID);

      // Add from trigger
      if (o.adaHiddenControl) {
        linkDefaults.modalIdArray.push(o.adaHiddenControl);
      }

      // Add from layerOptions
      if (layerOptions && layerOptions.adaHiddenControl) {
        linkDefaults.modalIdArray.push(layerOptions.adaHiddenControl);
      }

      // Remove focus trap window event
      window.removeEventListener('keydown', this.focusTrap, false);
      window.removeEventListener('touchend', this.focusTrap, false);

      // react appropriately depending on layer type
      var $layer;
      switch (o.type) {
        case 'modal':
          $layer = this._openModalLayer(o, $layer, $link);
          $layer.addClass(classDefaults.activeModal);
          this.options.$applicationContainer.addClass(classDefaults.activeModal);

          // Add focus trap and other ADA
          focusTrapSetter($layer, this);
          break;
        case 'info':
        case 'info-inline':
          $layer = this._openInfoLayer(o, $layer, $link);
          $layer.addClass(classDefaults.activeTooltip);
          this.options.$applicationContainer.addClass(classDefaults.activeTooltip);

          // Add focus trap and other ADA
          if (o.type === 'info-inline') {
            focusTrapSetter($layer, this);

            // Inline tooltips w/out a title need to get it from parent modal
            inlineTooltipAda(o);
          }
          break;
        case 'drawer':
          $layer = this._openModalLayer(o, $layer, $link);
          $layer.addClass(classDefaults.activeDrawer);
          this.options.$applicationContainer.addClass(classDefaults.activeDrawer);

          // Add focus trap and other ADA
          focusTrapSetter($layer, this);
          break;
        default:
          return;
      }

      // if JCR sets modal position, add it to spa-dialog class list
      if (o.layerPosition) {
        $layer[0].firstElementChild.classList.add("spa-ui-position-".concat(o.layerPosition.toLowerCase()));
      }

      // code to handle resizing
      var $modalElement = $layer.find('.spa-content');
      var $layerElement = $layer.find('.spa-card__body');
      var $contentDiv = $modalElement.find('.content');
      var $layerDiv = $layerElement.find('.content');
      var contentDiv = $contentDiv[0];
      var layertDiv = $layerDiv[0];
      var resizeContentBody = function resizeContentBody() {
        if (!contentDiv || !['drawer', 'modal'].includes(o.type)) {
          return;
        }
        var contentBodyChanged = false;

        // get and store off original max height
        var origMaxHeight = parseInt(contentDiv.getAttribute('data-orig-max-height'), 10);
        if (!origMaxHeight) {
          origMaxHeight = parseInt(window.getComputedStyle(contentDiv).maxHeight, 10);
          contentDiv.setAttribute('data-orig-max-height', origMaxHeight);
        }

        // If the height of the scrollable area is greater than the viewable height, reduce the
        // content window's max height.
        var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        if ($modalElement[0].scrollHeight > windowHeight) {
          var amountToReduce = $modalElement[0].scrollHeight - windowHeight;
          contentDiv.style.maxHeight = "".concat(contentDiv.offsetHeight - amountToReduce - 25, "px");
          contentBodyChanged = true;
        } else {
          // need to increase window, don't allow it to go over original max height
          var amountToIncrease = windowHeight - $modalElement[0].scrollHeight;
          if (contentDiv.offsetHeight + amountToIncrease > origMaxHeight) {
            contentDiv.style.maxHeight = "".concat(origMaxHeight, "px");
          } else if (amountToIncrease > 0) {
            contentDiv.style.maxHeight = "".concat(contentDiv.offsetHeight + amountToIncrease - 25, "px");
          }
          contentBodyChanged = true;
        }

        // if content changed, trigger a scroll event for updating layout
        if (contentBodyChanged) {
          $contentDiv.trigger('scroll.uilayer_content');
        }
      };

      // Only resize elements with class of `content`. Used primarily by interstitials.
      if (contentDiv) {
        resizeContentBody.call(this);
        this.options.$window.on('resize.closeModal orientationchange.closeModal', resizeContentBody.bind(this));
      }

      // Adjust tooltip heights so it's dynamic to window height.
      if (layertDiv && o.type === 'info' && o.enableDynamicHeight) {
        var tooltipDynamicHeight = function tooltipDynamicHeight() {
          _this3.tooltipDynamicHeight(layertDiv, $link);
        };
        this.tooltipDynamicHeight(layertDiv, $link);
        window.addEventListener('resize', window.tooltipFN = tooltipDynamicHeight, false);
        window.addEventListener('scroll', window.tooltipFN = tooltipDynamicHeight, false);
      }
      $layer.data('type', o.type);
      if (o.returnFocusToLink && o.returnFocusToLink[0] && o.returnFocusToLink[0].id) {
        $layer.data('returnFocusToLink', "#".concat(o.returnFocusToLink[0].id));
      } else {
        $layer.data('returnFocusToLink', 'body');
      }
      $layer.data('contentId', o.contentId);
      var tooltipWithinModal = false;
      if (this.options.$applicationContainer.find(".".concat(classDefaults.infoLayerClass)).length && this.options.$applicationContainer.find(constSelectors.layers).length) {
        // See if we're really inside of a modal or not
        var modalLookup = this.options.$applicationContainer.find(".".concat(classDefaults.infoLayerClass))[0];
        var hasTooltip = modalLookup.querySelector(constSelectors.layers);
        if (hasTooltip) {
          tooltipWithinModal = true;
        }
      }

      // common event handlers and actions
      var $closeButton = $layer.find(".".concat(this.options.closeClass)).eq(0);

      // Prevent bundling of close buttons if info-inline is inside modal
      $closeButton.each(function (index, element) {
        if (['drawer', 'modal'].includes(o.type) && $(element).closest(".".concat(linkDefaults.layerClass)).hasClass('spa-ui-info-info-inline')) {
          $closeButton.splice($.inArray(element, $closeButton), 1);
        }
      });

      // function for closing layer
      var _closeLayer = function _closeLayer() {
        this.closeLayer($layer);

        // stop listing for ESC
        if (o.type !== 'info-inline') {
          this.options.$body.off("keydown.".concat(this.options.evtNamespace));
        }
      };
      $closeButton.off("click.".concat(this.options.evtNamespace)).on("click.".concat(this.options.evtNamespace), _closeLayer.bind(this));

      // if ESC can dismiss this layer
      if (o.closeOnEscape && o.closeButton === true) {
        var _closeLayerOnEscape = function _closeLayerOnEscape(clickEvent) {
          if (clickEvent.keyCode === 27) {
            // ESC is reserved for modals if inline tooltip is present.
            if (o.type !== 'info-inline') {
              // Close layer.
              this.closeLayer($layer);

              // Stop listening for ESC.
              this.options.$body.off("keydown.".concat(this.options.evtNamespace));
            }
          }
        };
        this.options.$body.on("keydown.".concat(this.options.evtNamespace), _closeLayerOnEscape.bind(this));
      }

      // If clicking outside the layer, can dismiss the layer.
      if (o.closeOnClickOutside) {
        if (o.type !== 'info-inline') {
          var self = this;
          var mouseUpEvent = function mouseUpEvent(clickEvent) {
            if ($layer !== clickEvent.target && !$layer.has(clickEvent.target).length) {
              _this3.options.$body.off("mouseup.".concat(_this3.options.evtNamespace, "mouseUpEventFN"));
              self.closeLayer($layer);
            }
          };
          this.options.$body.on("mouseup.".concat(this.options.evtNamespace, "mouseUpEventFN"), mouseUpEvent.bind(this));

          // On tabbing out of the tooltip, see if layer should close
          if (o.type === 'info') {
            this.options.$body.on("keyup.".concat(this.options.evtNamespace, "keyupUpEventFN"), this.closeLayerOnKeyPress.bind(this, $layer));
          }

          // Tabbing through tooltip content, allow window to scroll internal content into view.
          this.options.$body.on("keyup.".concat(this.options.evtNamespace, "keyupUpScrollEventFN"), this.scrollWindowToFocusElement.bind(this, $layer));
        }
      }

      // Add optional close links/buttons. Pass in as a jQuery object.
      if (o.closeTriggers && o.closeTriggers.length) {
        $(o.closeTriggers).each(function (i, el) {
          var $closeLink = $layer.find(el);
          var _closeLayerWithTriggers = function _closeLayerWithTriggers() {
            this.closeLayer($layer);
          };
          $closeLink.click(_closeLayerWithTriggers.bind(_this3));
        });
      }
      if (o.onOpen && o.onOpen.length && o.onClose && o.onClose.length) {
        this._deprecated('The `onOpen` and `onClose` methods are no longer supported. Please use the Sparta Event Utility equivalents and `spartaEventUtility.MODAL_OPENED`/`spartaEventUtility.MODAL_CLOSED`.');
      }

      // allow another component to add custom content
      var addContent = function addContent(content) {
        $layer.find('.site-specific-placeholder-content').html(content);
        resizeContentBody.call(this);
      };

      // Allow another component to add custom content.
      var replaceContent = function replaceContent(content) {
        // Since `$layer` is a jQuery object, switch to a vanilla DOM element.
        if (!$layer || !$layer.length) {
          return;
        }
        var layer = $layer[0];
        if (!layer) {
          return;
        }

        // Break content into chunks.
        var target = layer.querySelector("#".concat(contentId), ".".concat(contentId));
        var loading = layer.querySelector('.spa-loading');
        var buttonGroup = target.querySelector('.spa-btn-group');
        var contentEl = target.querySelector('.site-specific-placeholder-content');

        // Remove focus on page and reset on close button.
        document.activeElement.blur();

        // Update content HTML.
        var html = document.createElement('div');
        html.classList.add('content');

        // If content is just a string, we can't `appendChild`.
        if (typeof content === 'string') {
          // Append doesn't work with strings, so we convert.
          html.insertAdjacentHTML('beforeend', content);
        } else {
          // Or else it's a DOM object, so we can `appendChild`.
          html.appendChild(content);
        }

        // Add previous content and any CTA groups.
        if (contentEl) {
          html.appendChild(contentEl);
        }
        if (buttonGroup) {
          html.appendChild(buttonGroup);
        }

        // If there is a loading element, hide it.
        if (loading) {
          loading.remove();
        }

        // Remove previous content.
        target.querySelector('.content').remove();

        // Update layer content.
        target.appendChild(html);
        target.style.display = 'block'; // show content if it was hidden by another function

        // Add focus back to modal since loading is complete.
        var dismissible = layer.querySelector('.spa-card__dismissible');
        if (dismissible) {
          dismissible.focus();
        }

        // Add tabindex for scrollable content.
        this.contentTabIndex($layer);
      };

      // Add tabindex 0 to scrollable content for both tooltip and modal
      var contentTabIndex = function contentTabIndex(layer) {
        var $spaBodyHeight = layer.find('.spa-card__body').height();
        var $bodyContent = layer.find('.content');
        if ($spaBodyHeight < $bodyContent[0].scrollHeight) {
          $bodyContent.attr('tabindex', '0');
        } else {
          $bodyContent.removeAttr('tabindex');
        }
      };

      // add loading text option to as a helper for ajax calls
      var addLoader = function addLoader(text) {
        // Since `$layer` is a jQuery object, switch to a vanilla DOM element.
        if (!$layer || !$layer.length) {
          return;
        }
        var layer = $layer[0];
        if (!layer) {
          return;
        }

        // Hide content.
        var content = layer.querySelector("#".concat(contentId, " .content"), ".".concat(contentId, " .content"));
        content.style.display = 'none';

        // Add loader.
        var loadingText = text || o.loadingText;
        var spaBody = layer.querySelector('.spa-body') ? layer.querySelector('.spa-body') : layer.querySelector('.spa-card__body');
        var loading = document.createElement('div');
        loading.innerHTML = loadingText;
        loading.classList.add('spa-loading');
        loading.setAttribute('tabindex', '-1');
        spaBody.appendChild(loading);
        var modalLoading = spaBody.querySelector('.spa-loading');
        if (modalLoading) {
          modalLoading.focus();
        }
      };

      // handle return link
      o.returnFocusToLink.addClass(this.options.openClass);

      // dispatch modal opened
      spartaEventsUtility.pub(EVENTS.MODAL_OPENED, {
        type: o.type,
        contentId: o.contentId,
        layer: $layer,
        trigger: triggerLink,
        addLoader: addLoader,
        addContent: addContent,
        replaceContent: replaceContent,
        contentTabIndex: contentTabIndex,
        returnFocusToLink: o.returnFocusToLink
      });

      // reveal to JAWs on open
      $layer.attr('aria-hidden', false);

      // Place layer content if it's sticky or not.
      // On resize and load.
      var breakpointInit = o && 'disableBP' in o ? o.disableBP : true;
      spartaEventsUtility.sub("".concat(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, ":").concat(o.layerId), function () {
        _this3.transportStickyFooter($layer);
      }, breakpointInit);

      // Add tabindex for scrollable content.
      contentTabIndex($layer);
      var layerWrapper = this.options.$applicationContainer.find("#".concat(o.layerId));
      if (layerWrapper.length > 0) {
        var contentTabIndexFn = function contentTabIndexFn() {
          setTimeout(function () {
            contentTabIndex($layer);
          }, 25);
        };
        window.contentTabIndexFn = contentTabIndexFn;
        window.removeEventListener('resize', window.contentTabIndexFn, false);
        window.addEventListener('resize', window.contentTabIndexFn, false);
      }

      // Add/remove shadow from layer with scrollable content.
      this._addAlphaLayer(o.type, $layer.find('.spa-card__body'), true);

      // ADA: always focus on close layer
      // Tie focus to transitionend so we know the DOM has been set.
      // eslint-disable-next-line consistent-return
      $layer.on('transitionend webkitTransitionEnd oTransitionEnd', function (thisEvent) {
        var trigger = thisEvent.target;
        var getActiveElement = document.activeElement;
        var layerHasActiveElement = $layer[0].contains(getActiveElement);
        if (trigger.classList.contains('spa-card') && !layerHasActiveElement) {
          if (tooltipWithinModal && $layer.hasClass(classDefaults.activeTooltip)) {
            $($layer).find('.spa-card__dismissible').eq(0).trigger('focus');
            return false;
          }
          if (o.dynamicContent === false && $layer.is(constSelectors.activeClasses)) {
            if (o.closeButton === false) {
              if (o.noCloseFocusAuto === true) {
                $layer.find(".".concat(classDefaults.noCloseFocus)).eq(0).trigger('focus');
              }
            } else if (!trigger.parentElement.classList.contains('spa-ui-info-info-inline')) {
              $($layer).find('.spa-card__dismissible:first-of-type').eq(0).trigger('focus');
              _this3.scrollWindowToFocusElement($layer, thisEvent);
            }
          }
        }
      });

      // Transition event doesn't capture everything, so lets make sure focus is set.
      var getTransitionFromCSS = window.getComputedStyle($layer[0]).getPropertyValue('animation-duration');
      if (getTransitionFromCSS) {
        var transitionTimer = parseFloat(getTransitionFromCSS) * (/\ds$/.test(getTransitionFromCSS) ? 1000 : 1);
        var getLayer = $layer[0];
        setTimeout(function () {
          var getActiveElement = document.activeElement;
          var layerHasActiveElement = getLayer.contains(getActiveElement);
          if (!layerHasActiveElement && getLayer.matches(constSelectors.activeClasses)) {
            if (o.closeButton === false) {
              if (o.noCloseFocusAuto === true) {
                getLayer.querySelector(".".concat(classDefaults.noCloseFocus)).focus();
              }

              // Set focus to modal if no dismissible
              var getLayerWraper = getLayer.querySelector('.spa-dialog');
              var getCloseElm = getLayerWraper.querySelector('.spa-card__dismissible:first-of-type');
              if (!getCloseElm) {
                getLayerWraper.setAttribute('tabindex', '-1');
                getLayerWraper.focus();
              }
            } else if (!getLayer.parentElement.classList.contains('spa-ui-info-info-inline')) {
              getLayer.querySelector('.spa-card__dismissible:first-of-type').focus();
            }
          }
        }, transitionTimer + 5);
      }
    }

    /**
     * Close a UI layer by ID, type all. Close will hide the layer and call any onClose handlers and
     * handle return focus.
     * @param {string|object} [layer] - The layer(s) you want to close as an ID or a jQuery object.
     * @param {string|object} actionOptions - Optional object to pass for increased functionality.
     * @returns {void}
     * @example spartaUILayer.closeLayer() // Close all open layers.
     * @example spartaUILayer.closeLayer('modal1'); // Close layer with ID `modal1`.
     * @example spartaUILayer.closeLayer($('#modal1')); // Close layer with ID `modal1`.
     * @example spartaUILayer.closeLayer($('.spa-ui-task, .spa-ui-info')); // Close info/task layers.
     */
  }, {
    key: "closeLayer",
    value: function closeLayer(layer) {
      var actionOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.isPrerender) {
        return;
      }

      // Layers will be passed in as a undefined (select all layers), as a string (select ID), or as
      // a jQuery selector.
      var $layer;
      if (typeof layer === 'undefined') {
        var layerTarget = $(".".concat(this.options.layerClass, ":not([vue-component=\"true\"])"));
        $layer = layerTarget;
      } else if (typeof layer === 'string') {
        $layer = this.options.$applicationContainer.find("#".concat(layer)).slice(0, 1);
      } else {
        $layer = $(layer);
      }
      if (this.options.$applicationContainer.find(".".concat(classDefaults.infoLayerClass)).length && this.options.$applicationContainer.find(constSelectors.layers).length) ;

      // no layers were found
      if ($layer.length === 0 || $layer[0].getAttribute('vue-component') === 'true') {
        return;
      }
      var _onEachItem = function _onEachItem(origLayer, index, element) {
        var _this4 = this;
        var $this = $(element).closest('.spa-ui-layer');
        var o = $this.data() || {};
        var getActionOptions = actionOptions;
        var $returnFocusToLink = o.returnFocusToLink;
        var doesElementExist = $this.closest('body').length > 0;
        var isCurrentlyShowing = $this.css('display') !== 'none';
        // Only close layers that aren't showing
        if (!isCurrentlyShowing || !doesElementExist) {
          return;
        }

        // Reset alpha states.
        $this.find('spa-card__head').removeClass('spa-card__head-box-shadow');
        $this.find('spa-card').removeClass('spa-card__body-box-shadow');
        $this.find('spa-card__body').removeClass('spa-card__body-box-shadow');
        $this.find('spa-card__foot').removeClass('spa-card__foot-box-shadow spa-card__foot-box-shadow--empty');

        // leave inline tooltip open on opening modal
        var openInfoInline = false;
        if (!origLayer && element.classList.contains('spa-ui-info-info-inline')) {
          openInfoInline = true;
        }

        // only 1 layer, handle return link
        if ($layer.length === 1) {
          // if our returnFocusToLink value isn't a jQuery collection, convert it to one
          if (!($returnFocusToLink instanceof $)) {
            $returnFocusToLink = this.options.$applicationContainer.find($returnFocusToLink).slice(0, 1);
          }

          // Check to see if focus should be reset.
          var setFocus = 'setFocusOnClose' in getActionOptions ? getActionOptions.setFocusOnClose : true;
          if (setFocus) {
            if (o.type === 'info-inline' && !openInfoInline) {
              // no need to loop if inline tooltip is closed
              $layer.slideToggle();
              $returnFocusToLink.focus();
            } else if ($returnFocusToLink.length && $returnFocusToLink.is(':visible')) {
              setTimeout(function () {
                $returnFocusToLink.removeClass(_this4.options.openClass).focus();
              }, 10);
            } else if (o.type === 'info' && $layer.prev().is(':visible')) {
              // If no return link and type is info, set focus to previous sibling since that
              // is always the trigger.
              $layer.prev().trigger('focus');
            } else {
              // It's either a modal or tooltip trigger isn't visible.
              this.options.$applicationContainer.focus();
            }
          }
        }

        // call standard layer type onclose call back
        if ($this.is(constSelectors.modalLayers)) {
          this._closeModalLayer($this);
        } else if ($this.hasClass(this.options.infoLayerClass) && o.type !== 'info-inline') {
          this._closeInfoLayer($this);
        }

        // call on close callback;
        // check to see if function is defined as module.function, then split
        spartaEventsUtility.pub(EVENTS.MODAL_CLOSED, {
          eventType: EVENTS.MODAL_CLOSED,
          type: o.type,
          contentId: o.contentId,
          layer: $layer,
          returnFocusToLink: o.returnFocusToLink
        });

        // Unsub from breakpoint resize event.
        spartaEventsUtility.unsubByEvent("".concat(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, ":").concat(o.contentId, "SpartaUILayer"));

        // Remove tooltip dynamic content listener
        if ($returnFocusToLink) {
          if (window.tooltipFN) {
            window.removeEventListener('resize', window.tooltipFN, false);
            window.removeEventListener('scroll', window.tooltipFN, false);
          }
        }

        // Update data object.
        $this.data('returnFocusToLink', null);

        // hide from JAWs on close
        $this.attr('aria-hidden', true);
        if (o.type === 'modal') {
          // If closing modal...
          this._bodyUnfreezeScroll($this);
          this.options.$applicationContainer.removeClass(classDefaults.activeModal);
          $layer.removeClass(classDefaults.activeModal);
        } else if (o.type === 'drawer') {
          // If closing drawer...
          this._bodyUnfreezeScroll($this);
          this.options.$applicationContainer.removeClass(classDefaults.activeDrawer);
          $layer.removeClass(classDefaults.activeDrawer);
        } else if ($this.hasClass(this.options.infoLayerClass)) {
          // If closing tooltip...
          this.options.$applicationContainer.removeClass(classDefaults.activeTooltip);
          $layer.removeClass(classDefaults.activeTooltip);
        }
      };

      // Here we should have jQuery selector of all layers to close.
      $layer.each(_onEachItem.bind(this, layer));
      this.options.$body.off("click.".concat(this.options.closeLayerNameSpace));
      this.options.$body.off("keyup.".concat(this.options.evtNamespace, "keyupUpScrollEventFN"));
    }

    /**
    * When body is set to `position: fixed`, this will keep the same content in the viewport. Before
    * this addition, the page would scroll to the top.
    * @returns {void}
    */
  }, {
    key: "_keepPageFromScrolling",
    value: function _keepPageFromScrolling() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.options.$body.css('top', -scrollTop);
    }

    /**
     * Prevent scrolling of body when layer is open.
     * @param {object} $layer - The layer that is opening.
     * @returns {void}
     */
  }, {
    key: "_bodyFreezeScroll",
    value: function _bodyFreezeScroll($layer) {
      if ($layer.length) {
        // keep track of where the scroll was left off
        if (!this.options.$body.hasClass('spa-ui-no-js-scroll')) {
          this._keepPageFromScrolling();
        }
        this.options.$body.addClass('spa-ui-freeze-scroll');
        spartaEventsUtility.pub(EVENTS.FREEZE_SCROLL);
      }
    }

    /**
    * When body `position: fixed` is reverted, scrolls user back to the previous location.
    * @returns {void}
    */
  }, {
    key: "_returnScrollLocation",
    value: function _returnScrollLocation() {
      var computedStyles = window.getComputedStyle(document.body, null);
      var topValue = computedStyles.getPropertyValue('top');
      var topValueToInteger = Math.abs(parseInt(topValue, 10));
      window.scrollTo(0, topValueToInteger);
      this.options.$body.css('top', '');
    }

    /**
     * Allows scrolling of body when layer is closed.
     * @param {object} $layer - The layer that is closing.
     * @returns {void}
     */
  }, {
    key: "_bodyUnfreezeScroll",
    value: function _bodyUnfreezeScroll($layer) {
      if ($layer.length && this.options.$body.hasClass('spa-ui-freeze-scroll')) {
        // remove our scroll-stopping class from the body
        this.options.$body.removeClass('spa-ui-freeze-scroll');

        // put the user back at their original scroll position
        if (!this.options.$body.hasClass('spa-ui-no-js-scroll')) {
          this._returnScrollLocation();
        }
        spartaEventsUtility.pub(EVENTS.UNFREEZE_SCROLL);
      }
    }

    /**
     * Standard close function for modal layers.
     * @param {object} $layer - Modal layer we are closing.
     * @returns {void}
     */
  }, {
    key: "_closeModalLayer",
    value: function _closeModalLayer($layer) {
      $layer.css('display', 'none');
      var $spaContent = $layer.find('.content');
      if ($spaContent && $spaContent.length) {
        $spaContent[0].scrollTop = 0;
        if ($spaContent.attr('tabindex')) {
          $spaContent.removeAttr('tabindex');
        }
        var $alphaLayer = $spaContent.find('.spa-content-alpha-layer');
        if ($alphaLayer && $alphaLayer.length) {
          $spaContent.off('scroll.uilayer_content');
        }
      }
      this.updatePageContainerADA($layer, false);
    }

    /**
     * Standard close function for info layers.
     * @param {object} $layer - Info layer we are closing.
     * @returns {void}
     */
  }, {
    key: "_closeInfoLayer",
    value: function _closeInfoLayer($layer) {
      if ($layer.hasClass('spa-ui-animate-fadeInDown')) {
        $layer.removeClass('spa-ui-animate-fadeInDown').addClass('spa-ui-animate-fadeOutUp');
      } else if ($layer.hasClass('spa-ui-animate-fadeInUp')) {
        $layer.removeClass('spa-ui-animate-fadeInUp').addClass('spa-ui-animate-fadeOutDown');
      }
      var $spaContent = $layer.find('.content');
      if ($spaContent.length) {
        $spaContent[0].scrollTop = 0;
        if ($spaContent.attr('tabindex')) {
          $spaContent.removeAttr('tabindex');
        }
      }
      var $alphaLayer = $spaContent.find('.spa-content-alpha-layer');
      if ($alphaLayer) {
        $spaContent.off('scroll.uilayer_content');
      }
    }

    /**
     * Sets the next Z-index for UI layer.
     * @returns {number} The Z-index.
     */
  }, {
    key: "_getNextZindex",
    value: function _getNextZindex() {
      return this.options.nextZIndex++;
    }

    /**
     * Format the close links for all layers per ADA requirements. Add `ada-hidden` text to the close
     * links to make sure they are unique and meaningful per ADA requirements using these rules.
     * Close `<span class="ada-hidden">Layer: {title or content as determined by rules}</span>`.
     * Rules to generate a unique close link:
     *   1. Pass in `closeAdaTextOverride`.
     *   2. Content from: `<h3>`, `<h2>`, `<h4>`, `.ada-title`.
     *   3. `returnFocusToLink` text.
     *   4. The first 50 characters of content from the first `<p>`.
     *   5. Default text: "close layer".
     * @param {object} o - Link configuration object.
     * @returns {void}
     */
  }, {
    key: "_formatCloseLink",
    value: function _formatCloseLink(o) {
      // Figure out the best text to use as an automatically-generated modal title.
      o.titleText = '';
      if (o.closeAdaTextOverride) {
        o.titleText = o.closeAdaTextOverride;
      } else {
        // Look for existing title.
        var existingTitle = o.$content.closest('.spa-card').find('.spa-card__title');
        var $titleEl = o.$content.find('.spa-ui-layer-title') ? o.$content.find('.spa-ui-layer-title') : o.$content.parent().find('.spa-ui-layer-title');

        // If there's an existing title, use it.
        if (existingTitle && existingTitle.length > 0) {
          $titleEl = existingTitle;
        } else {
          // Else get title from content.
          // Get title from layer content
          $titleEl = o.$content.find('.spa-ui-layer-title') ? o.$content.find('.spa-ui-layer-title') : o.$content.parent().find('.spa-ui-layer-title');

          // If no title found, get title based on type.
          if (!$titleEl.length && ['drawer', 'modal'].includes(o.type)) {
            $titleEl = o.$content.find('h1').first();
          } else if (!$titleEl) {
            $titleEl = o.$content.find('h3').first();
          }

          // If still no title, check content for other tag types.
          if (!$titleEl.length) {
            $titleEl = o.$content.find('h2').first();
          }
          if (!$titleEl.length) {
            $titleEl = o.$content.find('h4').first();
          }
          if (!$titleEl.length) {
            $titleEl = o.$content.find('.ada-title').first();
          }
        }

        // If found title, get the text.
        if ($titleEl.length) {
          o.titleText = $titleEl.text().trim();
        } else if (
        // Else use triggers text since no title could be found.
        o.returnFocusToLink.length && o.returnFocusToLink.text().length && !o.returnFocusToLink.is('[data-sparta-container]')) {
          o.titleText = o.returnFocusToLink.text().replace(/layer/g, '');
        } else {
          // As a last ditch effort, get a sub-string from inside layer content.
          var $paragraphEl = o.$content.find('p').first();
          if ($paragraphEl.length) {
            o.titleText = $paragraphEl.text().substr(0, 50);
          }
        }
      }

      // If no dismissible remove the 'close' section of the auto generated ADA message.
      if (o.closeButton === false) {
        o.closeText = ' ';
      }

      // Update the ADA close link text.
      var moreCloseText;
      if (['drawer', 'modal'].includes(o.type)) {
        moreCloseText = o.closeAdaText || spartaGlobalFunctions.getGlobalParams('closeModalADAText') || 'dialog';
      } else {
        moreCloseText = spartaGlobalFunctions.getGlobalParams('closeLayerADAText') || 'dialog';
      }
      o.closeAdaText += moreCloseText;
    }

    /**
     * Returns the horizontal center point of the triggering link and a relative X and Y value.
     * X can be -1, 0, or 1:
     *   * -1 means the layer should align to the left of the link
     *   * 0 means the layer should center on the link
     *   * 1 means the layer should align to the right of the link
     * Y can be -1 or 1:
     *   * -1 means the layer should open above the link
     *   * 1 menas the layer should open below the link
     * @param {object} $layer (the layer that is opening)
     * @param {object} $link (this link that triggered this layer)
     * @returns {object} Values for `x`, `y`, and `center`.
     */
  }, {
    key: "_getLayerPos",
    value: function _getLayerPos($layer, $link) {
      // `getBoundingClientRect` will give us the width, height, top, and left of the link relative
      // to the viewport.
      var link = $link[0].getBoundingClientRect();

      // Get viewport width and height. We'll need this to decide where to position the layer.
      var viewport = {
        width: this.options.$window.width(),
        height: this.options.$window.height()
      };

      // Get layer width and height. We'll need this to decide where to position the layer.
      var layer = {
        width: $layer.width(),
        height: $layer.height(),
        layerElm: $layer[0]
      };
      var center = this._getLinkCenter(link);

      // Return our positioning data.
      return {
        x: this._getLayerX(link, layer, viewport, $link),
        y: this._getLayerY(link, layer, viewport, $link),
        center: center
      };
    }

    /**
     * Returns the center point of the link relative to the app container.
     * @param {object} link - getBoundingClientRect for link element
     * @returns {number} The center point in pixels.
     */
  }, {
    key: "_getLinkAppCenter",
    value: function _getLinkAppCenter(link) {
      var appBoundingRect = this.options.$applicationContainer[0].getBoundingClientRect();
      return appBoundingRect.left + link.left + link.width / 2;
    }

    /**
     * Returns the center point of the link relative to the viewport.
     * @param {object} link - getBoundingClientRect for link element
     * @returns {number} The center point in pixels.
     */
  }, {
    key: "_getLinkCenter",
    value: function _getLinkCenter(link) {
      return link.left + link.width / 2;
    }

    /**
     * Figures out whether the layer should appear below or above the link.
     * @param {object} link - `getBoundingClientRect` for link element.
     * @param {object} layer - Layer width and height.
     * @param {object} viewport - Viewport width and height.
     * @param {object} $link - jQuery reference to link element.
     * @returns {number} -1 for above the link or 1 for below the link.
     */
  }, {
    key: "_getLayerY",
    value: function _getLayerY(link, layer, viewport, $link) {
      // Account for the tooltip caret when calculating how much of the tooltip might bleed offscreen.
      var CARET_HEIGHT = 8;
      var layerHeight = layer.height + CARET_HEIGHT;
      var bleedOffBottom = Math.max(0, link.bottom - (viewport.height - layerHeight));
      var bleedOffTop = Math.max(0, layerHeight - link.top);

      // Determine whether the tooltip should appear above (-1) or below (1) the link.
      var direction = bleedOffBottom && !bleedOffTop ? -1 : 1;

      // Allow a default position of "top" to override the calculated value if possible.
      var linkOptions = $link.data('options') || {};

      // If provided an object, get vertical placement from it.
      var placeVertical = _typeof(linkOptions.position) === 'object' && linkOptions.position.vertical ? linkOptions.position.vertical : linkOptions.position;

      // Define position placements.
      if (placeVertical === 'top') {
        direction = -1;
      } else if (placeVertical === 'bottom') {
        direction = 1;
      }
      return direction;
    }

    /**
     * Figures out how to align the layer horizontally.
     * @param {object} link - `getBoundingClientRect` for link element.
     * @param {object} layer - Layer width and height.
     * @param {object} viewport - Viewport width and height.
     * @param {object} $link - jQuery reference to link element.
     * @returns {number} A code indicating alignment:
     *   * -1 = align to left edge of link.
     *   * 0 = center horizontally on link.
     *   * 1 = align to right edge of link.
     *   * 2 = center horizontally on the page below the link.
     *   * 3 = layer content too large, open a modal window.
     */
  }, {
    key: "_getLayerX",
    value: function _getLayerX(link, layer, viewport, $link) {
      var appLeftBoundToLinkCenter = this._getLinkAppCenter(link); // app left bound to center of link
      var centerViewport = this._getLinkCenter(link);

      // If position has vertical and horizontal locations
      var linkOptions = $link.data('options') || {};

      // If specific tooltip alignment is requested.
      var chipHorizontalAlignment = _typeof(linkOptions.position) === 'object' && linkOptions.position.horizontal ? linkOptions.position.horizontal : linkOptions.position;

      // by default we'll return 0 and center the layer horizontally on the link
      var x = 0;
      var layerWidth = layer.width;
      if ($link.hasClass('icon-link')) {
        layerWidth = layer.width * 0.8;
      }
      var linkRight = viewport.width - centerViewport;
      // Left and right calculation forumlas.
      var placeCenter = layerWidth >= appLeftBoundToLinkCenter && layerWidth >= linkRight;
      var placeLeftEdge = appLeftBoundToLinkCenter - layerWidth <= 0;
      var placeRightEdge = centerViewport + layerWidth >= viewport.width;
      if (layerWidth >= viewport.width) {
        // If the layer width is greater then the viewport width, show a modal window.
        x = 3;
      } else if (placeCenter && !chipHorizontalAlignment) {
        // If the layer width is greater then the space available on either side, center the layer on
        // the screen.
        x = 2;
      } else if (placeLeftEdge || chipHorizontalAlignment === 'left') {
        // If the viewport width minus the left edge of the link is greater than the layer width,
        // align to the left edge of the link.
        x = -1;
      } else if (placeRightEdge || chipHorizontalAlignment === 'right') {
        // If the right edge of the link minus the layer width is greater than zero, align to the
        // right edge of the link.
        x = 1;
      }
      return x;
    }

    /**
     * Opens modal layers.
     * @param {object} o - Configuration object.
     * @param {object} $layer - jQuery reference to layer element.
     * @param {object} $link - jQuery reference to link element.
     * @returns {object} jQuery reference to layer element.
     */
  }, {
    key: "_openModalLayer",
    value: function _openModalLayer(o, $layer, $link) {
      // close any open layers
      this.closeLayer();

      // get layer from JCR params
      $layer = this.options.$applicationContainer.find("#".concat(o.layerId)).slice(0, 1);

      // layer has been opened before
      if ($layer.length) {
        // When interstitial modals of the same type are called within a page, we need to update the
        // URL being provided.
        if (this.layers[o.interstitialType]) {
          SpartaUILayersModal.updateModalCTA($layer, $link.attr('href'));
        } else {
          // Update modals that may have had their titles updated due to user action and closed.
          this._formatCloseLink(o);
          $($layer).find('.spa-card__dismissible').eq(0).attr('aria-label', "".concat(o.closeText));
        }
        $layer.removeClass('full-width');
        $layer.css('display', 'block');
      } else {
        // get ADA text
        this._formatCloseLink(o);

        // get content from card helper
        var modalDOMElement = SpartaUILayersModal.buildHTML(this, o, $link, classDefaults, linkDefaults);

        // append modal content to DOM
        this.options.$applicationContainer.append(modalDOMElement);

        // get layer now that we've appended it into DOM
        $layer = this.options.$applicationContainer.find("#".concat(o.layerId)).slice(0, 1);

        // add a flexbox wrapper to modal content
        $layer.wrapInner('<div class="spa-layer-content"></div>');

        // get desired, or default to type default
        if (o.type === 'modal') {
          var _widthValue = o.width || o.modalLayer.width;
          $layer.find('.spa-dialog').css('width', _widthValue);
        }
      }

      // Set interstitial modal bontinue button URLs
      // This supports the tag change from <a> to <button> which uses an event listener instead of HREF
      if (this.layers[o.interstitialType] || o.module === 'global-social-module') {
        // Get the open directions from the trigger
        var continueBtnElm = $layer[0].querySelector('.spa-ui-modal-btn--continue');
        var triggerLink = o.returnFocusToLink ? o.returnFocusToLink[0] : undefined;
        var targetAction = o.targetAction;
        if (continueBtnElm) {
          // Enables popup support for interstitial buttons
          var _self = this;
          function continueBtnPopup(e) {
            // get settings
            var continueSettings = e.currentTarget.setContinueBtnPopupSettings;
            // kill check
            if (Object.keys(continueSettings).length === 0) {
              _self.closeLayer();
              return false;
            }

            // run popup logic
            var triggerLink = continueSettings.triggerLink,
              modalInstance = continueSettings.modalInstance,
              options = continueSettings.options;
            var opts = modalInstance.getPopupArgs(triggerLink);
            modalInstance.displayPopup(opts.href, opts.windowName, opts.args);
            modalInstance.closeLayer(options.layerId);
          }

          // Reset existing listener
          continueBtnElm.removeEventListener('click', continueBtnPopup, false);
          continueBtnElm.setContinueBtnPopupSettings = {};
          continueBtnElm.removeEventListener('click', this.setContinueBtnUrl);
          continueBtnElm.setContinueBtnUrlSettings = {};

          // If trigger has popup action
          if (targetAction && targetAction === 'popup') {
            continueBtnElm.removeEventListener('click', continueBtnPopup, false);
            continueBtnElm.addEventListener('click', continueBtnPopup, false);
            continueBtnElm.setContinueBtnPopupSettings = {
              triggerLink: triggerLink,
              modalInstance: _self,
              options: o
            };
          } else {
            // Create new listener
            continueBtnElm.addEventListener('click', this.setContinueBtnUrl);
            continueBtnElm.setContinueBtnUrlSettings = {
              target: $layer ? $layer.find(".spa-ui-modal-btn--continue") : undefined,
              targetAction: o.targetAction,
              continueLink: o.module === 'global-social-module' ? o.interstitial.continueLink : $link.attr('href')
            };
          }
        }
      }

      // update layer param for listener attachments
      $layer = this.options.$applicationContainer.find("#".concat(o.layerId)).slice(0, 1);

      // Update options with the ADA hidden control so it is available on both open and close layer actions.
      this.options.adaHiddenControl = o.adaHiddenControl;

      // freeze body scroll, add alpha layer to bottom of scrollable area
      this._bodyFreezeScroll($layer);

      // layer is open, redo positioning logic
      var $modalDialog = $layer.find('.spa-dialog');
      var _layerWidth = $modalDialog.width();

      // RWD: if brower width > layer -> center
      if (o.position.browserWidth <= _layerWidth) {
        $modalDialog.addClass('full-width');
      }

      /**
       * Closes the modal on X icon close.
       * @returns {void}
       */
      function closeModal() {
        this.options.$window.off('resize.closeModal orientationchange.closeModal');
        this.closeLayer(o.layerId);
      }

      // add interstitial cancel button click event
      this.options.$applicationContainer.find('.close-interstitial.spa-btn').off('click').on('click', closeModal.bind(this));

      // ADA: Keep tabbing inside of modal
      this.updatePageContainerADA($layer, true);

      // add positioning class to modal from scripting instead of JCR
      if (classDefaults.layerPosition) {
        $modalDialog.parent().addClass("spa-ui-position-".concat(classDefaults.layerPosition.toLowerCase()));
      }
      return $layer;
    }

    /**
     * When clicking on an interstitial modal button, open its targeted link
     * This supports the change from <a> HREF attribute to using a <button> element instead
     * @param {Object} e Click event
     */
  }, {
    key: "setContinueBtnUrl",
    value: function setContinueBtnUrl(e) {
      // Get settings from window object
      var settings = e.currentTarget.setContinueBtnUrlSettings;

      // Get the vanilla JS element if we've been given a a jQuery element array
      settings.target = $.makeArray(settings.target);
      if (settings.target.length > 0) {
        settings.target = settings.target[0];
      }

      // Parse updated settings object
      var target = settings.target,
        targetAction = settings.targetAction,
        continueLink = settings.continueLink;
      var clickedElm = e.target || e.srcElement;

      // Add a data attr of target URL for ool-interstitial-utility to grab
      target.setAttribute('data-continue-link', '');
      if (continueLink) {
        target.setAttribute('data-continue-link', continueLink);

        // If the clicked element was our targeted element and we were given a URL
        if (target === clickedElm) {
          if (targetAction === 'new-tab') {
            window.open(continueLink, '_blank');
          } else {
            document.location.href = "".concat(continueLink);
          }
        }
      }
    }

    /**
     * Adds alpha layer and scroll watcher.
     * @param {string} layertype - The type of layer being used so we can get scrollable element.
     * @param {object} $baseLayer - Base layer item to watch as a jQuery object.
     * @param {boolean} addListener - Adds the jQuery event listener when true.
     * @returns {void}
     */
  }, {
    key: "_addAlphaLayer",
    value: function _addAlphaLayer(layertype, $baseLayer) {
      var addListener = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // Make sure we have a jQuery element
      $baseLayer = $baseLayer instanceof $ ? $baseLayer : $($baseLayer);
      var $spaBody = $baseLayer.hasClass('spa-card__body') ? $baseLayer : $baseLayer.find('.spa-card__body');
      var $spaCard = $spaBody.closest('.spa-card');
      var $bodyContent = layertype === 'info' ? $baseLayer.find('.content') : $baseLayer;

      // Run logic.
      var alphaLogic = function alphaLogic() {
        if ($spaBody.length === 0) {
          return;
        }

        // Get elemnets to test.
        var $spaHead = $spaCard.find('.spa-card__head');
        var $spaFoot = $spaCard.find('.spa-card__foot');
        var $spaBodyHeight = $spaBody.height();
        var hasFoot = $spaFoot && $spaFoot.length > 0;
        var emptyFootContent = $spaFoot.children().length === 0;
        var bodyScrolledPOS = $bodyContent[0].scrollHeight - $bodyContent.scrollTop() - $bodyContent.outerHeight();
        var bodyScrolledBottom = bodyScrolledPOS < 1;

        // If scrollbar in layer body.
        if ($spaBodyHeight < $bodyContent[0].scrollHeight) {
          // If scroll away from top, add shadow to head.
          if ($bodyContent[0].scrollTop > 0) {
            $spaHead[0].classList.add('spa-card__head-box-shadow');
          } else {
            $spaHead[0].classList.remove('spa-card__head-box-shadow');
          }

          // If no foot content, but body scrollable.
          if (emptyFootContent && !bodyScrolledBottom && bodyScrolledPOS > 8) {
            if (layertype === 'modal') {
              $spaCard[0].classList.add('spa-card__body-box-shadow');
            } else {
              $spaBody[0].classList.add('spa-card__body-box-shadow');
            }
          } else {
            $spaBody[0].classList.remove('spa-card__body-box-shadow');
            $spaCard[0].classList.remove('spa-card__body-box-shadow');
          }

          // If scroll away from top, add shadow to head.
          if (hasFoot && bodyScrolledBottom) {
            $spaFoot[0].classList.remove('spa-card__foot-box-shadow');
          } else if (hasFoot) {
            $spaFoot[0].classList.add('spa-card__foot-box-shadow');
          }
        }
        // No scrollbar, so reset classes.
        else {
          $spaHead[0].classList.remove('spa-card__head-box-shadow');
          $spaBody[0].classList.remove('spa-card__body-box-shadow');
          $spaCard[0].classList.remove('spa-card__body-box-shadow');
          if (hasFoot) {
            $spaFoot[0].classList.remove('spa-card__foot-box-shadow');
          }
        }

        // Hide footer if its empty.
        if (hasFoot && emptyFootContent) {
          $spaFoot[0].classList.add('spa-card__foot-box-shadow--empty');
        } else if (hasFoot) {
          $spaFoot[0].classList.remove('spa-card__foot-box-shadow--empty');
        }

        // Reset body min-height if it's to small.
        if ($bodyContent[0].scrollHeight < 225) {
          $bodyContent[0].style.minHeight = '';
        }
      };

      // Run logic.
      alphaLogic();
      if (addListener) {
        $spaBody.off('click.alphaLogicClick').on('click.alphaLogicClick', function () {
          alphaLogic();
        });
        $bodyContent.off('scroll.alphaLogicScroll').on('scroll.alphaLogicScroll', function () {
          alphaLogic();
        });
        $(window).off('resize.alphaLogicResize').on('resize.alphaLogicResize', function () {
          alphaLogic();
        });
      }
    }

    /**
     * Determines if alpha layer should be visible or not, based on scroll position.
     * @param {object} currentTarget - DOM element that fired the scroll event (`.content` section).
     * @param {object} $alphaLayer - The alpha layer element to reposition or show/hide.
     * @return {void}
     */
  }, {
    key: "_showHideAlphaOverlay",
    value: function _showHideAlphaOverlay(currentTarget, $alphaLayer) {
      var displayValue = 'none';

      // need to use this instead of .height() as JQuery adds elements and throws off measurement
      var alphaLayerHeight = 40;

      // only include things that would have room for the alpha's height
      if (currentTarget.scrollHeight > alphaLayerHeight) {
        // if not at the bottom of the scrollable area, modify CSS

        // to fix alpha-layer for modal in IE.
        if (currentTarget.scrollTop + currentTarget.clientHeight + 1 < currentTarget.scrollHeight) {
          displayValue = 'block';
        }
      }
      $alphaLayer.css('display', displayValue);
    }

    /**
     * Opens info layers.
     * @param {object} o - Configuration object.
     * @param {object} $layer - jQuery reference to layer element.
     * @param {object} $link - jQuery reference to link element.
     * @returns {object} jQuery reference to layer element.
     */
  }, {
    key: "_openInfoLayer",
    value: function _openInfoLayer(o, $layer, $link) {
      var _this5 = this;
      // layer doesn't exist yet
      var linkOptions = $link.data('options') || {};
      var tooltipMaxHeight = linkOptions.maxHeight || o.maxHeight || o.height || null;

      // allow access to global object within functions
      var _self = this;

      // Option to force layer to remain open by other events.
      var remainOpen = 'remainOpen' in o ? o.remainOpen : false;

      // find tooltip that's already been created
      $layer = this.options.$applicationContainer.find("#".concat(o.layerId));

      // Don't re-open layer if it's already open.
      if ($link.next().hasClass('spa-ui-layer') && $layer.find('.content').length && $layer.is(':visible') && !remainOpen) {
        var $layerFocusCheckDelay = 25;
        setTimeout(function () {
          if (o.type === 'info-inline') {
            // toggle inline tooltip
            var $closeButton = $layer.find(".".concat(_this5.options.closeClass));
            _this5.inlineTooltipSlideToggle($layer, $closeButton, 150);
          } else {
            _self.closeLayer($layer);
          }
        }, $layerFocusCheckDelay);
        return $layer;
      }

      // If no tooltip than create one.
      if (!$layer.find('.content').length) {
        // get ADA string for close link
        this._formatCloseLink(o);

        // build tooltip DOM element
        var infoLayerHTML = SpartaUILayersTooltip.buildHTML(this, o, $link);

        // append tooltip after trigger
        $link.after(infoLayerHTML);

        // add max-height for scrolling
        if (tooltipMaxHeight) {
          $(infoLayerHTML).find('.content').css('max-height', "".concat(tooltipMaxHeight, "px"));
        }

        // now add 'end of layer' text to tooltip since it's been appended
        infoLayerHTML.firstElementChild.appendChild(SpartaUILayersTooltip.createEndOfElement(o));

        // update $layer
        $layer = this.options.$applicationContainer.find("#".concat(o.layerId));
      }
      // If currently open, reset position.
      else if ($layer.hasClass('spa-ui-animate-fadeOutUp') || $layer.hasClass('spa-ui-animate-fadeOutDown')) {
        // Update tooltip title in case the same one is being triggered via different triggers.
        this._formatCloseLink(o);
        $($layer).find('.spa-card__dismissible').eq(0).attr('aria-label', "".concat(o.closeText, " ").concat(o.closeAdaText));

        // place tooltip in viewport
        $layer.show();

        // moves tooltip after trigger in DOM
        $link.after($layer);
        $layer.css('top', '');
      }
      // Inline tooltips.
      else if (o.type === 'info-inline') {
        // toggle inline tooltip
        var $closeButton = $layer.find(".".concat(this.options.closeClass));
        this.inlineTooltipSlideToggle($layer, $closeButton, 150);
      }

      // remove fadeout animation classes
      $layer.removeClass('spa-ui-info-modal spa-ui-animate-fadeOutUp spa-ui-animate-fadeOutDown');

      // Add custom max-width based on data options.
      if (o.width) {
        $layer.css('max-width', o.width);
      }

      // add max-height for scrolling
      if (tooltipMaxHeight) {
        // Hardcoded value
        if (tooltipMaxHeight.includes('px')) {
          tooltipMaxHeight = tooltipMaxHeight.replace('px', '');
        }

        // Set max-height
        $layer.find('.content').css('max-height', "".concat(tooltipMaxHeight, "px"));
      }

      // Is tooltip inside of a modal?
      var withinModal = this.options.$applicationContainer.find(constSelectors.modalLayers).find($link).length > 0;

      // place tooltip in viewport
      this._tooltipPositioning(_self, $layer, $link, withinModal, o);

      // update tooltip position on resize or scroll
      this.options.$window.on('scroll resize', function () {
        _self._tooltipPositioning(_self, $layer, $link, withinModal, o);
      });
      return $layer;
    }

    /**
     * Returns either a top or left position value for a given DOM element.
     * @param {object} element - The DOM element.
     * @param {string} position - Either `top` or `left`.
     * @returns {number} The calculated position value in pixels.
     */
  }, {
    key: "_getElementPosition",
    value: function _getElementPosition(element, position) {
      var elemRect = element.getBoundingClientRect();
      var appRect = this.options.$applicationContainer[0].getBoundingClientRect();
      if (position === 'top') {
        return elemRect.top - appRect.top;
      }
      return elemRect.left;
    }

    /**
     * Shared inline tooltip logic to reset or open it.
     * @param {*} $layer - UI layer.
     * @param {*} $closeButton - DOM element to trigger close.
     * @param {*} timer - How fast slide toggle runs for.
     * @returns {void}
     */
  }, {
    key: "inlineTooltipSlideToggle",
    value: function inlineTooltipSlideToggle($layer, $closeButton, timer) {
      var _this6 = this;
      $layer.slideToggle(timer, function () {
        if ($layer.is(':visible')) {
          $layer.attr('aria-hidden', 'false');
          $closeButton.attr('aria-hidden', 'false');
          $closeButton.trigger('focus');
        } else {
          _this6.closeLayer($layer);
        }
      });
    }

    /**
     * Toggles `aria-hidden` attribute to true or false.
     * @param {Array} $layer - jQuery array of the ui-layer elements
     * @param {boolean} isHidden - Boolean to toggle `aria-hidden` to.
     * @returns {void}
     */
  }, {
    key: "updatePageContainerADA",
    value: function updatePageContainerADA($layer, isHidden) {
      if (this.isPrerender) {
        return;
      }

      // Convert $layer to vanilla JS
      var layer = $layer instanceof $ && $layer.length > 0 ? $layer[0] : $layer;
      if (!layer) {
        return;
      }

      // Start process of setting aria-hidden on layer parents
      // testing from trigger: this.options.trigger[0]
      toggleSiblings(layer, isHidden);
    }

    /**
     * Prevents focus from leaving the modal by capturing the first and last focusable elements
     * @param {*} e event passed into the function
     */
  }, {
    key: "focusTrap",
    value: function focusTrap(e) {
      var settings = e.currentTarget.focusTrapSettings;
      var layer = document.querySelector('.spa-ui-modal.spa-ui-modal-open') || document.querySelector('.spa-ui-drawer.spa-ui-drawer-open') || settings.layer;
      var keyTab = 9;
      var isTabPressed = e.type === 'keydown' && (e.key === 'Tab' || e.keyCode === keyTab);

      // Kill check
      if (!layer || !(isTabPressed || e.type === 'touchend')) {
        return;
      }

      // Get list of all focusable elements on tab
      var focusableEls = _toConsumableArray(layer.querySelectorAll("\n      a[href]:not([disabled]),\n      button:not([disabled]),\n      textarea:not([disabled]),\n      input[type=\"text\"]:not([disabled]),\n      input[type=\"radio\"]:not([disabled]),\n      input[type=\"checkbox\"]:not([disabled]),\n      select:not([disabled]),\n      iframe,\n      [tabindex=\"0\"]\n    "));

      // Remove hidden elements from focus trap
      focusableEls = focusableEls.filter(function (element) {
        return element.offsetParent !== null;
      });
      if (focusableEls.length > 0) {
        var firstFocusableEl = focusableEls[0];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];

        // Tab controls
        if (e.key === 'Tab' || e.keyCode === keyTab) {
          // If clicked out of modal or nothing within is focused, send it back in on tab
          if (!layer.contains(document.activeElement)) {
            firstFocusableEl.focus();
            e.preventDefault();
          }
          // Shift + tab
          else if (e.shiftKey) {
            if (document.activeElement === firstFocusableEl) {
              lastFocusableEl.focus();
              e.preventDefault();
            }
          }
          // Tab
          else {
            if (document.activeElement === lastFocusableEl) {
              firstFocusableEl.focus();
              e.preventDefault();
            }
          }
        }
      }
    }

    /**
     * `console.log`s debug messages if `debug` is set to true.
     * @param {*} msg - The message to log.
     * @returns {void}
     */
  }, {
    key: "_debug",
    value: function _debug(msg) {
      if (this.options.debug) {
        // eslint-disable-next-line no-console
        console.log('ui-layer debug: ', msg);
      }
    }

    /**
     * `console.error`s debug messages if `debug` is set to true.
     * @param {*} msg - The message to log.
     * @returns {void}
     */
  }, {
    key: "_deprecated",
    value: function _deprecated(msg) {
      if (this.options.debug) {
        // eslint-disable-next-line no-console
        console.error("ui-layer DEPRECATED: ".concat(msg));
      }
    }

    /**
     * Positions the tooltip orientation to the trigger's position.
     * @param {object} _self - A reference to the context object.
     * @param {object} $layer - A jQuery reference to the layer element.
     * @param {object} $link - A jQuery reference to the link element.
     * @param {boolean} tooltipWithinModal - Indicates whether the tooltip is inside a modal.
     * @param {object} o - Options provided by utility on set up.
     * @returns {void}
     */
  }, {
    key: "_tooltipPositioning",
    value: function _tooltipPositioning(_self, $layer, $link, tooltipWithinModal, o) {
      // Get -1 or 1 depending on whether the layer should open above, below, left, center or right from the link.
      var layerPosition = _self._getLayerPos($layer, $link);
      var caretTarget = $layer.length ? $layer[0].querySelector('.spa-card') : undefined;

      // Get position of link relative to viewport.
      var linkViewportOffset = $link[0].getBoundingClientRect();
      var linkViewportOffsetTop = linkViewportOffset.top;

      // In the small viewport or if the layer width is too large, this layer should act like a modal.
      var newLeft = this._getElementPosition($link[0]);
      var layerCenter = $layer.outerWidth() / 2;
      var linkCenter = $link.outerWidth() / 2;

      // Get the type of tooltip being used
      var linkAsChip = $link[0].classList.contains('spa-chip-btn');

      // Available caret classes.
      var caretClasses = {
        top: 'card-caret-top',
        topRight: 'card-caret-top-right',
        topLeft: 'card-caret-top-left',
        bottom: 'card-caret-bottom',
        bottomRight: 'card-caret-bottom-right',
        bottomLeft: 'card-caret-bottom-left',
        right: 'card-caret-right',
        left: 'card-caret-left'
      };

      // Reset card carets.
      if (caretTarget) {
        Object.values(caretClasses).forEach(function (item) {
          caretTarget.classList.remove(item);
        });
      }

      // Set card caret decoration.
      if (caretTarget) {
        if (layerPosition.y === 1) {
          if (layerPosition.x === 0 || layerPosition.x === 2) {
            // Top center.
            caretTarget.classList.add(caretClasses.top);
          } else if (layerPosition.x === 1) {
            // Top right.
            caretTarget.classList.add(caretClasses.topRight);
          } else if (layerPosition.x === -1) {
            // Top left.
            caretTarget.classList.add(caretClasses.topLeft);
          }
        } else if (layerPosition.x === 0) {
          // Bottom center.
          caretTarget.classList.add(caretClasses.bottom);
        } else if (layerPosition.x === 1) {
          // Bottom right.
          caretTarget.classList.add(caretClasses.bottomRight);
        } else if (layerPosition.x === -1) {
          // Bottom left.
          caretTarget.classList.add(caretClasses.bottomLeft);
        }
      }

      // Tooltip positioning
      if ((layerPosition.x === -1 || layerPosition.x === 0) && linkAsChip) {
        // Chips should try and default to left position
        newLeft = this._getElementPosition($link[0]);
      } else if (layerPosition.x === 0) {
        // center position of trigger
        // differing center positions based on link type
        newLeft = newLeft - $layer.outerWidth() * 0.5 + linkCenter;
      } else if (layerPosition.x === 1) {
        // to right of trigger
        newLeft = newLeft - $layer.outerWidth() - 2 + $link.outerWidth();
      } else if (layerPosition.x === 2) {
        newLeft = linkViewportOffset.left - layerCenter + linkCenter;
      } else if (layerPosition.x === -1) {
        // to left of trigger
        // differing left positions based on link type
        if ($link.hasClass('icon-link')) {
          newLeft -= 40 - linkCenter * 1.9;
        }
      }
      $layer.css({
        position: '',
        top: '',
        left: "".concat(newLeft, "px"),
        right: '',
        height: '',
        'max-width': o.width || ''
      });
      if (!tooltipWithinModal) {
        // Above or below the link?
        if (layerPosition.y === -1) {
          // Above the link.
          var newTop = linkViewportOffsetTop - $layer.outerHeight() - this.options.layerLinkOffset;
          if ($link.hasClass('icon-link')) {
            newTop += this.options.layerIconOffset - 6;
          }

          // Layer positioning.
          $layer.css('top', "".concat(newTop, "px")).addClass('spa-ui-animate-fadeInUp').removeClass('spa-ui-animate-fadeInDown');
        } else if (layerPosition.y === 1) {
          // Below the link.
          var _newTop = linkViewportOffsetTop + this.options.layerLinkOffset + this.options.layerCaret;
          if ($link.hasClass('icon-link')) {
            _newTop += this.options.layerIconOffset;
          }

          // Layer positioning.
          $layer.css('top', "".concat(_newTop, "px")).addClass('spa-ui-animate-fadeInDown').removeClass('spa-ui-animate-fadeInUp').removeClass(caretClasses.top);
        }
      }

      // If the small viewport or the layer width is too large, then make it fit the device width
      // instead of positioning it under the trigger.
      if (tooltipWithinModal === true || spartaMediaQueryUtility.getCurrentViewport().mediaQueryInfo.medium === false) {
        // remove caret decoration
        Object.values(caretClasses).forEach(function (item) {
          if (caretTarget) {
            caretTarget.classList.remove(item);
          }
        });

        // place tooltip in DOM
        $layer.css('left', '10px');
        if (o.width) {
          $layer.css('max-width', 'calc(100% - 30px)');
        }
      }

      // if tooltip is inside of a modal
      if (tooltipWithinModal === true) {
        $layer.css({
          position: 'absolute',
          top: '',
          left: '10px',
          'max-width': 'calc(100% - 30px)',
          'margin-top': "".concat(this.options.layerLinkOffset, "px")
        });
      }

      // remove modal status
      $layer.removeClass('spa-ui-info-modal');
    } // END _tooltipPositioning

    /**
     * Allows tooltip height to be dynamic on open and resize events.
     * @param {object} contentDiv - the .content DOM element inside layer.
     * @param {object} $link - A jQuery reference to the link element.
     * @returns {void}
     */
  }, {
    key: "tooltipDynamicHeight",
    value: function tooltipDynamicHeight(contentDiv, $link) {
      if (!contentDiv || !$link) {
        return;
      }

      // Set a min height from CSS value
      if (contentDiv.scrollHeight < 225) {
        contentDiv.style.minHeight = '';
        return;
      }

      // Get the elements from jQuery objects.
      var getContent = contentDiv instanceof $ ? contentDiv[0] : contentDiv;
      var link = $link instanceof $ ? $link[0] : $link;

      // Get layer.
      var layer = getContent.closest('.spa-ui-layer');

      // Get layer head.
      var cardHead = layer && layer.querySelector('.spa-card__head') ? layer.querySelector('.spa-card__head') : undefined;
      var cardHeadHeight = cardHead ? cardHead.getBoundingClientRect().height : 0;

      // Get layer foot.
      var cardFoot = layer && layer.querySelector('.spa-card__foot') ? layer.querySelector('.spa-card__foot') : undefined;
      var cardFootHeight = cardFoot ? cardFoot.getBoundingClientRect().height : 0;
      var triggerBottomPosition = link.getBoundingClientRect().bottom > 0 ? link.getBoundingClientRect().bottom + (cardHeadHeight + cardFootHeight) : cardHeadHeight + cardFootHeight;

      // CardPartsOffset number comes from 225 base + 68 for card head single line height.
      var cardPartsOffset = 293 - (cardHeadHeight + cardFootHeight);
      var bottomDistanceOffset = 66;
      var bottomDistance = window.innerHeight - triggerBottomPosition - bottomDistanceOffset;
      contentDiv.style.maxHeight = "".concat(bottomDistance, "px");

      // Set a min height from CSS value
      if (contentDiv.scrollHeight > cardPartsOffset) {
        contentDiv.style.minHeight = "".concat(cardPartsOffset, "px");
      } else {
        contentDiv.style.minHeight = '';
      }

      // Once we've updated CSS let's check if alpha layers are needed.
      this._addAlphaLayer('info', contentDiv);
    }

    /**
     * Helper function to manually update the modal title.
     * @param {object} modalId - Unique DOM ID of modal to target.
     * @param {object} content - HTML or text to inject into title.
     * @param {boolean} updateAdaText - Update the ADA dismissible string on change.
     *                              Per ADA 2.1 updateAdaText should be `false` by default.
     * @returns {void}
     */
  }, {
    key: "setModalTitle",
    value: function setModalTitle(modalId, content) {
      var updateAdaText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (this.isPrerender) {
        return;
      }

      // Find the layer.
      var $layer = this.options.$applicationContainer.find("#".concat(modalId).concat(classDefaults.adaLayerID));
      if (!$layer.length) {
        $layer = this.options.$applicationContainer.find("#".concat(modalId));
      }

      // If the layer exists, update its title.
      if ($layer.length) {
        SpartaUILayersModal.setTitle($layer, content, updateAdaText, modalId);
      }
    }

    /**
     * Helper function to manually update the tooltip title.
     * @param {object} tooltipId - Unique DOM ID of tooltip to target.
     * @param {object} content - HTML or text to inject into title.
     * @param {boolean} updateAdaText - Update the ADA dismissible string on change.
     *                              Per ADA 2.1 updateAdaText should be `false` by default.
     * @returns {void}
     */
  }, {
    key: "setTooltipTitle",
    value: function setTooltipTitle(tooltipId, content) {
      var updateAdaText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (this.isPrerender) {
        return;
      }

      // Find the layer.
      var $layer = this.options.$applicationContainer.find("#".concat(tooltipId).concat(classDefaults.adaLayerID));
      if (!$layer.length) {
        $layer = this.options.$applicationContainer.find("#".concat(tooltipId));
      }

      // If the layer exists, update its title.
      if ($layer.length) {
        SpartaUILayersTooltip.setTitle($layer, content, updateAdaText, tooltipId);
      }
    }

    /**
     * Creates a sticky footer layer in the card foot.
     * @param {*} layerElement - DOM element to form ui layer
     * @param {*} layerOptions - the 'o' object from utility.
     * @returns {void}
     */
  }, {
    key: "createStickyFooter",
    value: function createStickyFooter(layerElement, layerOptions) {
      var layerFooterElement = document.createDocumentFragment();
      var contentFooter = layerElement.querySelector('[data-modal-footer]') ? layerElement.querySelector('[data-modal-footer]') : '';
      if (contentFooter) {
        // Get data options for footer config settings.
        var footerClasses = _toConsumableArray(contentFooter.classList);
        var footerConfig = layerOptions.foot && layerOptions.foot.config ? layerOptions.foot.config : {};
        var footerLayout = footerConfig.layout || 'inline';
        var footerUnsticky = footerConfig.unsticky || {
          small: true,
          medium: false,
          large: false
        };
        var footerStack = {
          desktop: 'stackOnDesktop' in footerConfig ? footerConfig.stackOnDesktop : false,
          tablet: 'stackOnTablet' in footerConfig ? footerConfig.stackOnTablet : false,
          mobile: 'stackOnMobile' in footerConfig ? footerConfig.stackOnMobile : false
        };

        // Create empty DOM element to hold sticky
        layerFooterElement = document.createElement('div');

        // Attach classes.
        footerClasses.push('spa-card__foot', 'spa-card__foot--sticky');
        footerClasses.forEach(function (item) {
          return layerFooterElement.classList.add(item);
        });

        // Attach data attributes for styling/JS hooks.
        layerFooterElement.setAttribute('data-sticky', JSON.stringify(footerUnsticky));
        layerFooterElement.setAttribute('data-layout', footerLayout);
        Object.keys(footerStack).forEach(function (key) {
          if (key in footerStack) {
            layerFooterElement.setAttribute("data-stacked-".concat(key), footerStack[key]);
          }
        });

        // Add content.
        if (contentFooter.children && contentFooter.children.length > 0) {
          var content = _toConsumableArray(contentFooter.children);
          content.forEach(function (element) {
            layerFooterElement.appendChild(element);
          });
        }
      }

      // Return the footer content.
      return layerFooterElement;
    }

    /**
     * Checks if layer footer content should be sticky or not.
     * @param {*} layer - DOM element to parse through.
     * @param {*} forceSticky - Force placement of DOM.
     * @returns {void}
     */
  }, {
    key: "transportStickyFooter",
    value: function transportStickyFooter(layer, forceSticky) {
      // If we've been given a jQuery object, convert it to vanilla.
      var activeLayer = layer;
      if (layer instanceof $) {
        activeLayer = $(layer)[0];
      }

      // Kill check
      if (!activeLayer) {
        return;
      }

      // Get DOM elements.
      var layerBody = activeLayer.querySelector('.spa-card__body');
      var layerFooter = activeLayer.querySelector('.spa-card__foot');

      // Ensure we have both a body and footer target.
      if (layerBody && layerFooter) {
        var layerSticky = layerBody.querySelector('[data-modal-footer="sticky"]');
        var dataSticky = layerFooter.getAttribute('data-sticky') ? JSON.parse(layerFooter.getAttribute('data-sticky')) : undefined;

        // If content can be unstickied, transport DOM.
        if (dataSticky && layerSticky) {
          // If options, see if sticky is part of them.
          var unstick = forceSticky || this.getLayerStickyBoolean(dataSticky);

          // Get DOM elements to move.
          var stickyItems = unstick ? _toConsumableArray(layerFooter.children) : _toConsumableArray(layerSticky.children);

          // Place in layer body.
          if (unstick) {
            stickyItems.forEach(function (item) {
              layerSticky.appendChild(item);
            });
          }
          // Place back in layer footer.
          else {
            stickyItems.forEach(function (item) {
              layerFooter.appendChild(item);
            });
          }
        }
      }
    }

    /**
     * Returns boolean on if layer should be sticky or not.
     * @param {*} data - Layer 'foot' object that may contain 'unsticky' object.
     * @returns {void}
     */
  }, {
    key: "getLayerStickyBoolean",
    value: function getLayerStickyBoolean(data) {
      // If options, see if sticky is part of them.
      var unstick = false;
      if (data) {
        // Determine if sticky should still be sticky.
        var stickyOptions = data;
        var viewport = spartaMediaQueryUtility.getCurrentViewport().mediaQueryInfo;
        if (viewport.large && viewport.medium && viewport.small) {
          unstick = 'large';
        } else if (!viewport.large && viewport.medium && viewport.small) {
          unstick = 'medium';
        } else {
          unstick = 'small';
        }
        unstick = stickyOptions[unstick];
      }
      return unstick;
    }

    /**
     * When focus leaves the tooltip close the layer.
     * @param {object} $layer Used to get layer wrapper.
     * @param {object} layerOptions Used to get the return link.
     * @param {object} event Event passed from listener.
     * @returns {void}
     */
  }, {
    key: "closeLayerOnKeyPress",
    value: function closeLayerOnKeyPress($layer, event) {
      var keyCode = event.charCode || event.keyCode;
      var getActiveElement = document.activeElement;

      // Get layer wrapper
      var contentLayer;
      if ($layer) {
        contentLayer = $layer[0];
      }
      var layertype = contentLayer.classList.contains('spa-ui-modal') ? 'modal' : 'popup';

      // If pressed tab but focus is no longer in layer or on chip trigger.
      if (keyCode === 9 // tab
      && !contentLayer.contains(getActiveElement) && layertype !== 'modal') {
        // Close layer
        this.closeLayer($layer, {
          setFocusOnClose: false
        });

        // Remove event.
        this.options.$body.off("keyup.".concat(this.options.evtNamespace, "keyupUpEventFN"));
      }
    }

    /**
     * If tooltip content is off screen and focusable, scroll it into view.
     * @param {object} $layer Used to get layer wrapper.
     * @param {object} event Event passed from listener.
     * @returns {void}
     */
  }, {
    key: "scrollWindowToFocusElement",
    value: function scrollWindowToFocusElement($layer, event) {
      var keyCode = event.charCode || event.keyCode;
      var target = $(document.activeElement);

      // Kill if focus element is not inside layer.
      if (target && target.length > 0 && !target[0].contains(document.activeElement)) {
        return;
      }

      // Get window cords.
      var layerTop = $layer.offset().top;
      var layerTopH = $layer.height();
      var elementTop = target.offset().top;
      var elementBottom = elementTop + target.outerHeight();
      var viewportH = $(window).height();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      var isNotInViewport = !(elementBottom > viewportTop && elementTop < viewportBottom);

      // Scroll window to place target center in viewport.
      var offset = layerTopH < viewportH ? elementTop - (viewportH / 2 - layerTopH / 2) : layerTop;

      // If tabbing inside of tooltip || no keycode was given (function was fired manually)
      //    && layer is not in viewport.
      if ((keyCode === 9 || keyCode === undefined) && isNotInViewport) {
        $([document.documentElement, document.body]).animate({
          scrollTop: offset
        }, 350);
      }
    }
  }]);
}();
var instance;

// this will get the widget name/version from the script tag. if it is loaded in a widget
var widgetName, widgetVersion;
try {
  if (document.currentScript) {
    widgetName = document.currentScript.getAttribute("widget-name");
    widgetVersion = document.currentScript.getAttribute("widget-version");
    if (widgetName) {
      var widgetObj = window.spaWidgetParams[widgetName][widgetVersion];
      widgetObj.singletonUtiiltiyInitializers = widgetObj.singletonUtiiltiyInitializers || [];
      instance = new SpartaUILayersUtility();
      widgetObj.singletonUtiiltiyInitializers.push(instance._initForWidgets.bind(instance));
    }
  }
} catch (e) {
  console.error('Failed to process currentScript attributes');
}
var index = instance || new SpartaUILayersUtility();
export { index as default };